import React from "react";
import {
  Button,
  Col,
  FormLabel,
  Row,
  Table,
  FormControl,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { NEW_ENTRY } from "../ds/App_Constants.js";
import { BaseBean, NodeData, PageListBean } from "../ds/client_ds.js";
import {
  CheckTransactionPaymentDetailBean,
  FabricStyleBean,
  PurchaseOrderReceiptSearchCriteria,
  PurchaseOrderSearchCriteria,
  ReasonBean,
  RestEntityUnLockRequest,
  RestPageListBean,
  RestPurchaseOrderListRequest,
  RestPurchaseOrderReceiptListRequest,
  RestReadRequest,
  RestVendorInvoiceListRequest,
  RestVendorInvoiceRequest,
  RestVendorListRequest,
  VendorInvoiceAdjustmentAmountBean,
  VendorInvoiceBean,
  VendorInvoiceLineBean,
  VendorInvoiceLinesSearchCriteriaBean,
  VendorInvoiceMiscellaneousAmountDetailsBean,
  VendorInvoicePurchaseOrderBean,
  VendorInvoicePurchaseOrderReceiptBean,
  VendorInvoiceSearchCriteria,
  VendorSearchCriteria,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import {
  AddIcon,
  CancelIcon,
  DeleteIcon,
  DropDwnDown,
  DropDwnUp,
} from "../gui_components/Icons.js";
import {
  AlertToolBox,
  DataGridColumnDefinition,
  DatePickerComponent,
    DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ReasonCaptureComponent,
  ShortCutMenuPopup,
  ShowError,
   ColumnDefinition,
  MessageBoxComponent,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
    toCommaSeperatedAmount,
  toFormattedDate_v1,
} from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { PurchaseOrderLookupHandler } from "../lookup/PurchaseOrderLookupHandler.js";
import { VendorInvoiceLookupHandler } from "../lookup/VendorInvoiceLookupHandler.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import { PopupPurchaseOrderModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { AccountPayableService } from "../services/AccountPayableService.js";
import { PurchaseOrderReceiptService } from "../services/PurchaseOrderReceiptService.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
import { VendorService } from "../services/VendorService.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import CustomTable from "../gui_components/CustomTable.js";
class VendorList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.adjReasonRef = React.createRef();
    this.adjAmountRef = React.createRef();
    this.miscReasonRef = React.createRef();
    this.miscReasonDescRef = React.createRef();
    this.miscAmountRef = React.createRef();
    this.miscPORef = React.createRef();
    this.miscRemarksRef = React.createRef();
    this.poLineRef = React.createRef();
    this.poPurchaseOrderRef = React.createRef();
    this.poOrderDateRef = React.createRef();
    this.poOrderStopDateRef = React.createRef();
    this.poReceiptsRef = React.createRef();
    this.purchaseRef = React.createRef();
     this.unapproveReasonDialogRef = React.createRef();
    this.state = {
      nodeList: [],
      pageTitle: "Vendor Invoice",
      pageList: new PageListBean(),
      vendorInvoiceCriteria: new VendorInvoiceSearchCriteria(),
      vendorInvoiceMiscellaneousAmountDetailsData:
        new VendorInvoiceMiscellaneousAmountDetailsBean(),
      vendorInvoiceAdjustmentData: new VendorInvoiceAdjustmentAmountBean(),
      vendorInvoicePurchaseOrderData: new VendorInvoicePurchaseOrderBean(),
      purchaseReceipts: new VendorInvoicePurchaseOrderReceiptBean(),
      vendorInvoicePurchaseOrderReceiptData:
        new VendorInvoicePurchaseOrderReceiptBean(),
      selectedNodeKey: "headerView",
      isLoading: false,
      isEntryFormOpen: false,
      isListFormOpen: true,
      vendorInvoiceList: [],
      moduleCaption: "VendorInvoice",
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      vendorInvoiceData: new VendorInvoiceBean(),
      vendorInvoiceLineData: new VendorInvoiceLineBean(),
      adjustmentAmounts: VendorInvoiceBean.adjustmentAmounts,
      miscellaneousAmountDetails:
        VendorInvoicePurchaseOrderBean.miscellaneousAmountDetails,
      invoicePurchaseOrders:
        VendorInvoicePurchaseOrderBean.invoicePurchaseOrders,
      isFabricStyleDataLoding: false,
      fabricStyleList: [],
      isDisableFields: false,
      fabricStyleData: new FabricStyleBean(),
      colorList: [],
      isShowBackButton: false,
      isShowCancelButton: true,
      isShowSaveButton: true,
      vendorInvoiceMiscellaneousReasons: [],
      vendorInvoiceAdjustmentReasons: [],
      paymentTerms: [],
      paymentMethods: [],
      customerRepresentatives: [],
      freightMethods: [],
      shipVias: [],
      salesClerk: [],
      errorList: [],
      cityList: [],
      stateList: [],
      countryList: [],
      salesPersonList: [],
      expenseTypes: [],
      expenseSubTypes: [],
      currencies: [],
      adjustmentReasons: [],
      vendorInvoiceMiscellaneousReasons: [],
      isInvoiceLinesDetailsFormOpened: false,
      isPaymentDetailViewOpen: false,
      isHistoryFormOpened: false,
      isDocumentsFormOpened: false,
      isNotesFormOpened: false,
      isPurchaseOrdersFormOpened: false,
      isChangesHistoryFormOpened: false,
      isShowNodes: false,
      nodeList: [],
      reasonData: new ReasonBean(),
      cancelReasons: [],
      unapprovalReasons: [],
      dependentPurchaseOrderList: [],
      isShowApproveButton: false,
      isShowUnApproveButton: false,
      isShowGeneratePickTicketButton: false,
      isListView: false,
      isResetModule: false,
      isResetView: false,
      vendorInvoiceLookupHandler: null,
      isFocusLookup: true,
      moduleOrderStatus: "",
      showAutoCompleteList: true,
      isMaintenanceMode: true,
      isDisabledFields: false,
      isSpecialViewMode: false,
      order: "asc",
      sortField: "",
      vendorInvoiceLinesList: [],
      editedVendorInvoiceLineList: [],
      isShowMiscPopup: false,
      isShowPOPopup: false,
      isShowAdjustmentPopup: false,
      isShowReceiptsPopup: false,
      isShowAlertLvl5: false,
      isShowAlertlvl3: false,
      isShowPurchaseOrderModule: false,
      purchaseOrderReceipts: [],
      availableReceipts: [],
      selectedReceipts: [],
      isShowPOLookup: false,
      purchaseorderLookupHandler: null,
      receipts: [],
      receiptsWithKey: [],
      isShowAutoCompleteExpenseTypeList: false,
      expenseTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteExpenseSubTypeList: false,
      expenseSubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCurrencyList: false,
      currencyPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteMiscreasonList: false,
      miscReasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteAdjReasonList: false,
      adjReasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteVendorList: false,
      vendorPageListForAutoCompleteList: new Array(),
      isShowAutoCompletePoList: false,
      poPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteMiscPoList: false,
      MiscPoPageListForAutoCompleteList: new Array(),
      vendorShipVias: [],
      vendorTerms: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      adjReasonLookupHandler: null,
      miscPurchaseOrderLookupHandler: null,
      isShowCancelReasonPopup: false,
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      paymentDetailList: new Array(),
      disabled: false,
      is3PL: false,
      isReseted: false,
      isViewMode: false,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    ModuleUtils.getVendorInvoiceStatusList();
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.setState({ is3PL: true });
    }
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };

    const vendorInvoiceMiscellaneousReasons = new Array();
    if (!isEmptyArray(attribute_cache.vendorInvoiceMiscellaneousReasons))
      vendorInvoiceMiscellaneousReasons.push(
        ...attribute_cache.vendorInvoiceMiscellaneousReasons
      );
    this.state.vendorInvoiceMiscellaneousReasons =
      vendorInvoiceMiscellaneousReasons;

    const vendorInvoiceAdjustmentReasons = new Array();
    if (!isEmptyArray(attribute_cache.vendorInvoiceAdjustmentReasons))
      vendorInvoiceAdjustmentReasons.push(
        ...attribute_cache.vendorInvoiceAdjustmentReasons
      );

       const unapprovalReasons = new Array();
    if (!isEmptyArray(attribute_cache.vendorInvoiceUnapprovalReasons))
      unapprovalReasons.push(...attribute_cache.vendorInvoiceUnapprovalReasons);

    this.state.unapprovalReasons = unapprovalReasons;
    this.state.vendorInvoiceAdjustmentReasons = vendorInvoiceAdjustmentReasons;

    this.state.vendorInvoiceCriteria = new VendorInvoiceSearchCriteria();
    this.state.vendorInvoiceCriteria.companyCode = this.companyCode;
    this.state.pageList = new PageListBean();
    this.state.pageList.pageSize = 50;
    this.loadCacheDetails();
    this.initLookupHandlers();
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;
      // this.unlockVendorInvoice(this.props.code);
      this.editVendorInvoice(this.props.code);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisabledFields: true,
        isDisableFields: true,
        isViewMode: false,
      });
    } else {
      this.addNewEntry();
    }
  }
  initLookupHandlers = () => {
    let vendorInvoiceLookupHandler = new VendorInvoiceLookupHandler(
      this.companyCode,
      "VendorInvoice"
    );
    this.setState({
      vendorInvoiceLookupHandler: vendorInvoiceLookupHandler,
    });
    let adjReasonLookupHandler = new GenericAttributeLookupHandler(
      this.state.vendorInvoiceAdjustmentReasons,
      "Adjustment Reason"
    );
    this.setState({
      adjReasonLookupHandler: adjReasonLookupHandler,
    });
    let purchaseOrderLookupHandler = new PurchaseOrderLookupHandler(
      this.companyCode,
      "PurchaseOrder",
      "",
      "R"
    );
    this.setState({
      miscPurchaseOrderLookupHandler: purchaseOrderLookupHandler,
    });
    let miscellaneousReasonsLookupHandler = new GenericAttributeLookupHandler(
      this.state.vendorInvoiceMiscellaneousReasons,
      "Miscellanious Reason"
    );
    this.setState({
      miscellaneousReasonsLookupHandler: miscellaneousReasonsLookupHandler,
    });
  };
  loadCacheDetails = () => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };

    const expenseTypes = new Array();
    if (!isEmptyArray(attribute_cache.expenseTypes))
      expenseTypes.push(...attribute_cache.expenseTypes);
    this.state.expenseTypes = expenseTypes;

    const expenseSubTypes = new Array();
    if (!isEmptyArray(attribute_cache.expenseSubTypes))
      expenseSubTypes.push(...attribute_cache.expenseSubTypes);
    this.state.expenseSubTypes = expenseSubTypes;

    const currencies = new Array();
    if (!isEmptyArray(attribute_cache.currencies))
      currencies.push(...attribute_cache.currencies);
    this.state.currencies = currencies;

    const adjustmentReasons = new Array();
    if (!isEmptyArray(attribute_cache.inventoryAdjustmentReasons))
      adjustmentReasons.push(...attribute_cache.inventoryAdjustmentReasons);
    this.state.adjustmentReasons = adjustmentReasons;

    const cancelReasons = new Array();
    if (!isEmptyArray(attribute_cache.purchaseOrderCancelReasons))
      cancelReasons.push(...attribute_cache.purchaseOrderCancelReasons);
    this.state.cancelReasons = cancelReasons;
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  handleApproveResponse = (response) => {
    let success = false;
    let mainResponseSuccess = false;
    let additionalResponseSuccess = false;

    let errMsg = "";
    let infoMsg = "";
    let errList = [];
    if (response.mainOperationResponse != null) {
      if (response.mainOperationResponse.errors != null) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + "\n" + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
        mainResponseSuccess = false;
      }
      if (response.mainOperationResponse.infos != null) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + "\n" + info.messageDescription)
        );
        mainResponseSuccess = true;
        let successMsg = [];
        successMsg.push(infoMsg);
        this.setState({
          alertMessage: successMsg,
          alertType: "success",
          isShowAlert: true,
        });
      }
    }
    if (response.additionalOperationResponse != null) {
      if (response.additionalOperationResponse.errors != null) {
        response.additionalOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + "\n" + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
        additionalResponseSuccess = false;
      }
      if (response.additionalOperationResponse.infos != null) {
        response.additionalOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + "\n" + info.messageDescription)
        );
        additionalResponseSuccess = true;
        let successMsg = [];
        successMsg.push(infoMsg);
        this.setState({
          alertMessage: successMsg,
          alertType: "success",
          isShowAlert: true,
        });
      }
    }
    success = mainResponseSuccess && additionalResponseSuccess;
    return success;
  };
  loadVendorInvoiceResponse = (response) => {
    let vendorInvoiceList = new Array();
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.vendorInvoicePageList)
    ) {
      vendorInvoiceList = response.data.vendorInvoicePageList.vendorInvoices;
      this.state.pageList.totalCount =
        response.data.vendorInvoicePageList.totalCount;
      this.state.pageList.currentPage =
        response.data.vendorInvoicePageList.currentPage;
    } else {
      vendorInvoiceList = new Array();
    }
    let loading = this.state.isLoading;
    loading = false;
    this.setState({
      isLoading: loading,
      vendorInvoiceList: vendorInvoiceList,
    });
  };
  loadVendorInvoiceError = (error) => {
    ShowError("Error : ", error);
  };
  loadVendorInvoice = () => {
    let requestInput = new RestVendorInvoiceListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.vendorInvoiceCriteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.VendorInvoiceView_IsAccessible()) {
      AccountPayableService.getVendorInvoices(
        requestInput,
        this.loadVendorInvoiceResponse,
        this.loadVendorInvoiceError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  filterVendorInvoice = () => {
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  resetFilteredVendorInvoice = () => {
    let criteria = new VendorInvoiceSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.vendorInvoiceCriteria = criteria;
    this.setState({ vendorInvoiceCriteria: criteria });
    this.loadPage(1);
  };
  onCriteriaChange = (e) => {
    let criteria = this.state.vendorInvoiceCriteria;
    criteria.companyCode = this.companyCode;
    criteria["vendorInvoiceCode"] = e.target.value;
    this.setState({ vendorInvoiceCriteria: criteria });
  };
  onPurchaseOrderChange = (e) => {
    let vendorInvoiceData = this.state.vendorInvoiceData;
    let temp_vendorInvoicePurchaseOrderData =
      this.state.vendorInvoicePurchaseOrderData;
    temp_vendorInvoicePurchaseOrderData[e.target.name] = e.target.value;
    if (e.target.name === "lineNumber") {
      temp_vendorInvoicePurchaseOrderData["lineNumber"] = e.target.value;
    } else if (e.target.name === "purchaseOrderNumber") {
      temp_vendorInvoicePurchaseOrderData["purchaseOrderNumber"] =
        e.target.value;
    } else {
      temp_vendorInvoicePurchaseOrderData[e.target.name] = e.target.value;
    }
    this.setState({
      vendorInvoicePurchaseOrderData: temp_vendorInvoicePurchaseOrderData,
    });
  };
  clearPOLineValues = (e) => {
    if (e.detail == 1) {
      if (this.poLineRef.current != null) {
        this.poLineRef.current.clear();
      }
      if (this.poPurchaseOrderRef.current != null) {
        this.poPurchaseOrderRef.current.clear();
      }
      if (this.poOrderDateRef.current != null) {
        this.poOrderDateRef.current.clear();
      }
      if (this.poOrderStopDateRef.current != null) {
        this.poOrderStopDateRef.current.clear();
      }
      if (this.poReceiptsRef.current != null) {
        this.poReceiptsRef.current.clear();
      }
      let newLineBean = new VendorInvoicePurchaseOrderBean();
      this.setState({
        vendorInvoicePurchaseOrderData: newLineBean,
        purchaseReceipts: [],
        purchaseOrderReceipts: [],
        availableReceipts: [],
        selectedReceipts: [],
        receipts: [],
      });
    }
  };
  getVendorInvoiceLineDetails = () => {
    let vendorInvoiceData = this.state.vendorInvoiceData;
    let vendorInvoicePurchaseOrderData =
      this.state.vendorInvoicePurchaseOrderData;
    this.state.isLineEditMode = true;
    let vendorCode = vendorInvoiceData.vendorCode;
    let readrestInput = new VendorInvoiceLinesSearchCriteriaBean();
    readrestInput.companyCode = this.companyCode;
    readrestInput.vendorCode = vendorCode;
    readrestInput.invoiceReceiptCodes.push(...this.state.receipts);
    readrestInput.loadChildren = true;
    if (SecurityAccessManager.VendorInvoiceView_IsAccessible()) {
      AccountPayableService.getVendorInvoiceLines(
        readrestInput,
        this.loadVendorInvoiceLinesResponse,
        this.loadVendorInvoiceLinesError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getPurchaseOrderMaxLineNumber() {
    let maxLineNumber = 0;
    let poLineFormData = this.state.vendorInvoiceData.invoicePurchaseOrders;
    if (poLineFormData.length > 0)
      poLineFormData.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  onAdjustmentChange = (e) => {
    let vendorInvoiceData = this.state.vendorInvoiceData;
    let temp_vendorInvoiceAdjustmentData =
      this.state.vendorInvoiceAdjustmentData;
    temp_vendorInvoiceAdjustmentData[e.target.name] = e.target.value;
    if (e.target.name === "adjustmentReason") {
      temp_vendorInvoiceAdjustmentData["adjustmentReason"] = e.target.value;
    } else if (e.target.name === "adjustmentAmount") {
      temp_vendorInvoiceAdjustmentData["adjustmentAmount"] = e.target.value;
    }
    {
      temp_vendorInvoiceAdjustmentData[e.target.name] = e.target.value;
    }
    this.setState({
      vendorInvoiceAdjustmentData: temp_vendorInvoiceAdjustmentData,
    });
  };
  validateAdjustmentLines = (lineBean) => {
    let isValidAdjLine = false;
    let err_list = [];
    let errorMessage = "";
    if (lineBean == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(lineBean.adjustmentReason)) {
        let errMsg = "Reason is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (lineBean.adjustmentAmount == 0) {
        let errMsg = "Amount is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidAdjLine = false;
      this.setState({ errorList: err_list });
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvl5: true,
        isShowAlert: false,
      });
    } else {
      isValidAdjLine = true;
      this.setState({ isShowAlertLvl5: true, isShowAlert: false });
    }
    return isValidAdjLine;
  };
  addOrUpdate_Adj_Reason = (e) => {
    if (e.detail == 1) {
      let vendorInvoiceData = this.state.vendorInvoiceData;
      let vendorInvoiceAdjustmentData = this.state.vendorInvoiceAdjustmentData;
      let adjData = vendorInvoiceAdjustmentData;
      adjData.companyCode = this.companyCode;
      adjData.vendorInvoiceCode = this.state.vendorInvoiceData.code;
      let isValid = false;
      isValid = this.validateAdjustmentLines(adjData);
      if (isValid) {
        let existingLine = this.getAdjLineByLineNumber(adjData.lineNumber);
        if (existingLine === null) {
          let adjLines = new Array();
          adjLines.push(adjData);
          if (vendorInvoiceData.adjustmentAmounts == null) {
            this.state.vendorInvoiceData.adjustmentAmounts = adjLines;
          } else {
            this.state.vendorInvoiceData.adjustmentAmounts.push(adjData);
          }
          var lineNumber = this.getAdjMaxLineNumber();
          adjData.lineNumber = ++lineNumber;
        } else {
          const index =
            this.state.vendorInvoiceData.adjustmentAmounts.findIndex(
              (ln) => ln.lineNumber === existingLine.lineNumber
            );
          if (index != -1) {
            this.state.vendorInvoiceData.adjustmentAmounts.splice(index, 1);
            this.state.vendorInvoiceData.adjustmentAmounts.push(adjData);
          }
        }
        this.calculateTotal();
        this.closeAlertModalCallBacklvl5(false);
      }
    }
  };
  getAdjMaxLineNumber() {
    let maxLineNumber = 0;
    let adjLine = this.state.vendorInvoiceData.adjustmentAmounts;
    if (adjLine.length > 0) {
      let lineNumber = adjLine.length - 1;
      if (lineNumber > maxLineNumber) {
        maxLineNumber = lineNumber;
      }
    }
    return maxLineNumber;
  }
  getAdjLineByLineNumber = (lineNumber) => {
    let adjLine = null;
    let adjDetails = this.state.vendorInvoiceData.adjustmentAmounts;
    if (adjDetails === null) return adjLine;
    else {
      adjDetails.map((line) => {
        if (line.lineNumber === lineNumber) {
          adjLine = line;
          return adjLine;
        }
      });
    }
    return adjLine;
  };
  clearAdjLineValues = (e) => {
    if (e.detail == 1) {
      let newLineBean = new VendorInvoiceAdjustmentAmountBean();
      this.setState({
        vendorInvoiceAdjustmentData: newLineBean,
      });
    }
  };
  onMiscellaneousChange = (e) => {
    let temp_vendorInvoiceMiscellaneousAmountDetailsData =
      this.state.vendorInvoiceMiscellaneousAmountDetailsData;
    temp_vendorInvoiceMiscellaneousAmountDetailsData[e.target.name] =
      e.target.value;
    if (e.target.name === "reasonCode") {
      temp_vendorInvoiceMiscellaneousAmountDetailsData["reasonCode"] =
        e.target.value;
    } else if (e.target.name === "reasonDescription") {
      temp_vendorInvoiceMiscellaneousAmountDetailsData["reasonDescription"] =
        e.target.value;
    } else if (e.target.name === "miscellaneousAmount") {
      temp_vendorInvoiceMiscellaneousAmountDetailsData["miscellaneousAmount"] =
        e.target.value;
    } else if (e.target.name === "purchaseOrderNumber") {
      temp_vendorInvoiceMiscellaneousAmountDetailsData["purchaseOrderNumber"] =
        e.target.value;
    } else if (e.target.name === "remarks") {
      temp_vendorInvoiceMiscellaneousAmountDetailsData["remarks"] =
        e.target.value;
    } else {
      temp_vendorInvoiceMiscellaneousAmountDetailsData[e.target.name] =
        e.target.value;
    }
    this.setState({
      vendorInvoiceMiscellaneousAmountDetailsData:
        temp_vendorInvoiceMiscellaneousAmountDetailsData,
    });
  };
  deleteAdjLines = (line) => {
    let vendorInvoiceData = this.state.vendorInvoiceData;
    let lineData = vendorInvoiceData.adjustmentAmounts;
    let miscdata = this.state.miscellaneousAmountDetails;
    if (line.isFetched == false) {
      var index = lineData.indexOf(line);
      if (index > -1) {
        lineData.splice(index, 1);
      }
    } else {
    }
    vendorInvoiceData.adjustmentAmounts = lineData;
    this.setState({
      vendorInvoiceData: vendorInvoiceData,
    });
    this.calculateTotal();
  };
  reArrangePoLineNumbers = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  reArrangeMiscLineNumbers = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  deletePoLines = (line) => {
    let vendorInvoiceData = this.state.vendorInvoiceData;
    let lineData = vendorInvoiceData.invoicePurchaseOrders;
    if (!line.isFetched) {
      var index = lineData.indexOf(line);
      if (index > -1) {
        lineData.splice(index, 1);
      }
      vendorInvoiceData.invoicePurchaseOrders = lineData;
      this.reArrangePoLineNumbers(lineData);
      this.setState({
        vendorInvoiceData: vendorInvoiceData,
      });
      this.calculateTotal();
    }
  };
  deleteMiscLines = (line) => {
    let vendorInvoiceData = this.state.vendorInvoiceData;
    let lineData = vendorInvoiceData.miscellaneousAmountDetails;
    let miscdata = this.state.miscellaneousAmountDetails;
    if (!line.isFetched) {
      var index = lineData.indexOf(line);
      if (index > -1) {
        lineData.splice(index, 1);
      }
      vendorInvoiceData.miscellaneousAmountDetails = lineData;
      this.reArrangeMiscLineNumbers(lineData);
      this.setState({
        vendorInvoiceData: vendorInvoiceData,
      });
      this.calculateTotal();
    }
  };
  validateMiscLines = (lineBean) => {
    let isValidMiscLine = false;
    let err_list = [];
    let errorMessage = "";
    if (lineBean == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(lineBean.reasonCode)) {
        let errMsg = "Reason is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (lineBean.miscellaneousAmount == 0) {
        let errMsg = "Amount is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidMiscLine = false;
      this.setState({ errorList: err_list });
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvl5: true,
        isShowAlert: false,
      });
    } else {
      isValidMiscLine = true;
      this.setState({ isShowAlertLvl5: true, isShowAlert: false });
    }
    return isValidMiscLine;
  };
  addOrUpdate_Miscellaneous = (e) => {
    if (e.detail == 1) {
      let vendorInvoiceData = this.state.vendorInvoiceData;
      let miscData = this.state.vendorInvoiceMiscellaneousAmountDetailsData;
      let miscLines = vendorInvoiceData.miscellaneousAmountDetails;
      let isValid = false;
      isValid = this.validateMiscLines(miscData);
      if (isValid) {
        var lineNumber = this.getMiscMaxLineNumber();
        let isLineFound = false;
        if (!isEmptyArray(miscLines)) {
          miscLines.map((line, i) => {
            if (line.lineNumber == miscData.lineNumber) {
              miscLines[i] = miscData;
              isLineFound = true;
            }
          });
        }
        if (!isLineFound) {
          miscData.lineNumber = ++lineNumber;
          miscLines.push(miscData);
        }
        vendorInvoiceData.miscellaneousAmountDetails = miscLines;
        this.setState({ vendorInvoiceData: vendorInvoiceData });
        this.calculateTotal();
        this.closeAlertModalCallBacklvl5();
      }
    }
  };
  getMiscMaxLineNumber() {
    let maxLineNumber = 0;
    let miscLine = this.state.vendorInvoiceData.miscellaneousAmountDetails;
    if (miscLine.length > 0) {
      miscLine.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    }
    return maxLineNumber;
  }
  getMiscLineByLineNumber = (lineNumber) => {
    let miscLine = null;
    let miscDetails = this.state.vendorInvoiceData.miscellaneousAmountDetails;
    if (miscDetails === null) return miscLine;
    else {
      miscDetails.map((line) => {
        if (line.lineNumber === lineNumber) {
          miscLine = line;
          return miscLine;
        }
      });
    }
    return miscLine;
  };
  clearMiscLineValues = (e) => {
    if (e.detail == 1) {
      let newLineBean = new VendorInvoiceMiscellaneousAmountDetailsBean();
      this.setState({
        vendorInvoiceMiscellaneousAmountDetailsData: newLineBean,
      });
    }
  };
  getMiscLineDetails = (rowData) => {
    let vendorMiscLinedata = { ...rowData };
    if (
      vendorMiscLinedata.code == null ||
      vendorMiscLinedata.code.length == 0
    ) {
      this.state.isLineEditMode = true;
      this.state.vendorInvoiceMiscellaneousAmountDetailsData.reasonCode =
        vendorMiscLinedata.reasonCode;
      this.setState({
        vendorInvoiceMiscellaneousAmountDetailsData: vendorMiscLinedata,
      });
    } else {
      this.state.isLineEditMode = false;
      this.state.vendorInvoiceMiscellaneousAmountDetailsData.reasonCode =
        vendorMiscLinedata.reasonCode;
      this.setState({
        vendorInvoiceMiscellaneousAmountDetailsData: vendorMiscLinedata,
      });
    }
    this.openMiscPopup();
  };
  getAdjustmentLineDetails = (code, rowData) => {
    let vendorAdjLinedata = { ...rowData };
    if (vendorAdjLinedata.code == null || vendorAdjLinedata.code.length == 0) {
      this.state.isLineEditMode = true;
      this.setState({
        vendorInvoiceAdjustmentData: vendorAdjLinedata,
      });
    } else {
      this.state.isLineEditMode = false;
      this.setState({
        vendorInvoiceAdjustmentData: vendorAdjLinedata,
      });
    }
    this.openAdjPopup();
  };
  validateAddPoLines = (lineBean) => {
    let vendorInvoiceData = this.state.vendorInvoiceData;
    let isValidPoLine = false;
    let err_list = [];
    let errorMessage = "";
    if (lineBean == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(lineBean.purchaseOrderNumber)) {
        let errMsg = "purchaseOrderNumber is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyArray(this.state.receipts)) {
        let errMsg = "PurchaseReceiptNumber is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (!isEmptyArray(vendorInvoiceData.invoicePurchaseOrders)) {
        vendorInvoiceData.invoicePurchaseOrders.map((ln) => {
          if (ln.purchaseOrderNumber === lineBean.purchaseOrderNumber) {
            let errMsg = "PurchaseOrder Already Exist";
            errorMessage = errorMessage + errMsg;
            err_list.push(errMsg);
          }
        });
      }
    }
    if (err_list.length > 0) {
      isValidPoLine = false;
      this.setState({ errorList: err_list });
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvl5: true,
        isShowAlert: false,
      });
    } else {
      isValidPoLine = true;
      this.setState({ isShowAlertLvl5: true, isShowAlert: false });
    }
    return isValidPoLine;
  };
  saveVendorPurchaseOrderLine = (e) => {
    if (e.detail == 1) {
      let vendorInvoiceData = this.state.vendorInvoiceData;
      let vendorInvoicePurchaseOrderData =
        this.state.vendorInvoicePurchaseOrderData;
      let invoicePoLines = vendorInvoiceData.invoicePurchaseOrders;
      let isValid = false;
      isValid = this.validateAddPoLines(vendorInvoicePurchaseOrderData);
      if (isValid) {
        var lineNumber = this.getVendorInvoicePoLineNumber();
        let isLineFound = false;
        if (!isEmptyString(invoicePoLines)) {
          invoicePoLines.map((line, i) => {
            if (line.lineNumber == vendorInvoicePurchaseOrderData.lineNumber) {
              line.purchaseReceipts =
                vendorInvoicePurchaseOrderData.purchaseReceipts;
              invoicePoLines[i] = line;
              isLineFound = true;
            }
          });
        }
        if (!isLineFound) {
          vendorInvoicePurchaseOrderData.lineNumber = ++lineNumber;
          invoicePoLines.push(vendorInvoicePurchaseOrderData);
        }
        vendorInvoiceData.invoicePurchaseOrders = invoicePoLines;
        this.setState({ vendorInvoiceData: vendorInvoiceData });
        this.getVendorInvoiceLineDetails();
        this.closeAlertModalCallBacklvl5();
      }
    }
  };
  getVendorInvoicePoLineNumber() {
    let maxLineNumber = 0;
    let poLines = this.state.vendorInvoiceData.invoicePurchaseOrders;
    if (poLines.length > 0)
      poLines.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  getVendorInvoiceLineNumber() {
    let maxLineNumber = 0;
    let invoiceLines = this.state.vendorInvoiceData.invoiceLines;
    if (invoiceLines.length > 0)
      invoiceLines.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  saveVendorInvoiceLine = () => {
    let vendorInvoiceData = this.state.vendorInvoiceData;
    let invoiceLine = this.state.vendorInvoiceLineData;
    let invoiceLines = vendorInvoiceData.invoiceLines;
    var lineNumber = this.getVendorInvoiceLineNumber();
    let isLineFound = false;
    if (invoiceLines != null || !isEmptyArray(invoiceLines)) {
      invoiceLines.map((line, i) => {
        if (line.lineNumber == invoiceLine.lineNumber) {
          line.cost = invoiceLine.cost;
          line.invoiceQuantity = invoiceLine.invoiceQuantity;
          line.receivedQuantity = invoiceLine.receivedQuantity;
          line.lineAmount = invoiceLine.lineAmount;
          invoiceLines[i] = line;
          isLineFound = true;
        }
      });
    }
    if (!isLineFound) {
      invoiceLine.lineNumber = ++lineNumber;
      invoiceLines.push(invoiceLine);
    }
    this.setState({
      vendorInvoiceData: vendorInvoiceData,
    });
    this.clearInvoiceLineValues();
  };
  handlePoLineNumberClick = (rowData) => {
    let vendorPoData = { ...rowData };
    let receipts = [];
    vendorPoData.purchaseReceipts.map((ln) => {
      receipts.push(ln.purchaseReceiptNumber);
    });
    this.setState({
      vendorInvoicePurchaseOrderData: vendorPoData,
      receipts: receipts,
    });
    this.openPOPopup();
  };
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let vendorInvoiceData = this.state.vendorInvoiceData;
    let headerObject = this.getEmptyView();
    let invoiceLinesDetailsObject = this.getEmptyView();
    let historyObject = this.getEmptyView();
    let paymentDetailObject = this.getEmptyView();
    let headerNode = new NodeData("headerView", "Header", headerObject);
    let orderDetailsNode = new NodeData(
      "invoiceLinesView",
      "InvoiceLinesDetails",
      invoiceLinesDetailsObject
    );
    let orderHistoryNode = new NodeData(
      "historyView",
      "History",
      historyObject
    );
    let paymentDetailNode = new NodeData(
      "paymentDetailView",
      "PaymentDetail",
      paymentDetailObject
    );
    nodeList["headerView"] = headerNode;
    nodeList["invoiceLinesView"] = orderDetailsNode;
    if (vendorInvoiceData.isFetched) {
      nodeList["historyView"] = orderHistoryNode;
      nodeList["paymentDetailView"] = paymentDetailNode;
    }
    this.setState({ nodeList: nodeList });
  };
  addNewEntry = () => {
    let vendorInvoiceData = new VendorInvoiceBean();
    vendorInvoiceData.companyCode = this.companyCode;
    vendorInvoiceData.code = NEW_ENTRY;
    vendorInvoiceData.originalVendorInvoiceAmount = 0;
    vendorInvoiceData.currencyCode = "USD";
    vendorInvoiceData.status = LogicConstants.VENDOR_INVOICE_OPEN_STATUS;
    // let date = new Date();
    // let currentDate = date.toLocaleDateString("sv-SE");
     let currentDate = toFormattedDate_v1(new Date());
    vendorInvoiceData.invoiceDate = currentDate;
    if (
      !isEmptyString(this.state.moduleKeyCode) ||
      this.state.moduleKeyCode != NEW_ENTRY
    ) {
      vendorInvoiceData.code = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == NEW_ENTRY) {
        this.isLocked = false;
      } else {
        this.isLocked = true;
      }
    } else vendorInvoiceData.code = NEW_ENTRY;
    let pageTitle = this.state.moduleCaption + " -" + NEW_ENTRY;
    this.state.isDisableFields = false;
    this.state.vendorInvoiceData = vendorInvoiceData;
    this.setState({
      vendorInvoiceData: vendorInvoiceData,
      pageTitle: pageTitle,
    },()=>{
       this.openEntryForm();
    });
   // this.state.vendorInvoiceData = vendorInvoiceData;
   
  };
  getEmptyView() {
    return <div></div>;
  }
  moduleExit = () => {
    let vendorInvoiceData = this.state.vendorInvoiceData;
    if (vendorInvoiceData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockVendorInvoice(vendorInvoiceData.code);
      } else {
        this.isLocked = false;
      }
      this.props.onModuleExit();
    }
  };
  resetView = () => {
    let vendorInvoiceData = new VendorInvoiceBean();
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode)
        this.unlockVendorInvoice(this.state.vendorInvoiceData.code);
    } else {
      this.isLocked = false;
    }

    this.setState({
      vendorInvoiceData: vendorInvoiceData,
      isResetModule: true,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isFocusLookup: true,
      isShowAutoCompleteExpenseTypeList: false,
      expenseTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteExpenseSubTypeList: false,
      expenseSubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCurrencyList: false,
      currencyPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteMiscreasonList: false,
      miscReasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteAdjReasonList: false,
      adjReasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteVendorList: false,
      vendorPageListForAutoCompleteList: new Array(),
      isShowAutoCompletePoList: false,
      poPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteMiscPoList: false,
      MiscPoPageListForAutoCompleteList: new Array(),
      isDisableFieldUnApprove: false,
    });
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.state.moduleKeyCode = NEW_ENTRY;
    this.hideAlertCallBack();
    this.addNewEntry();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  selectButtonClick = (e) => {
    this.editVendorInvoice(this.state.moduleKeyCode);
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  getModuleListView = () => {
    let vendorInvoiceData = this.state.vendorInvoiceData;
    if (vendorInvoiceData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadVendorInvoice();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockVendorInvoice(vendorInvoiceData.code);
      } else {
        this.isLocked = false;
      }
      this.closeEntryForm();
      this.loadVendorInvoice();
    }
  };
  closeEntryForm = () => {
    this.closeAllNodeViews();
    this.setState({
      isListFormOpen: true,
      isEntryFormOpen: false,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowBackButton: true,
      isShowPDFReportButton: false,
      isShowApproveButton: true,
      isShowUnApproveButton: true,
      isShowCancelButton: false,
      isShowModuleSearchContainer: false,
      isShowNodes: false,
      isResetView: false,
      isDisableFields: false,
      moduleKeyCode: NEW_ENTRY,
      moduleOrderStatus: "",
      isMaintenanceMode: false,
      isViewMode: false,
      isSpecialViewMode: false,
      isDisabledFields: false,
       isDisableFieldUnApprove: false,
    });
  };
  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "headerView") {
      this.setVendorInvoiceHeaderView();
    } else if (selectedNode == "invoiceLinesView") {
      this.setVendorInvoiceLinesView();
    } else if (selectedNode == "historyView") {
      this.setVendorInvoiceHistoryView();
    } else if (selectedNode == "paymentDetailView") {
      this.setPaymentDetailView();
    }
  };
  setVendorInvoiceHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      // isShowSaveButton: true,
      isShowBackButton: false,
      isEntryFormOpen: true,
      isInvoiceLinesDetailsFormOpened: false,
      isHistoryFormOpened: false,
      isPaymentDetailViewOpen: false,
    });
    this.initModuleButtons();
  };
  setVendorInvoiceLinesView = () => {
    this.closeAllNodeViews();
    this.setState({
      // isShowSaveButton: true,
      isShowBackButton: false,
      isInvoiceLinesDetailsFormOpened: true,
      isEntryFormOpen: false,
      isHistoryFormOpened: false,
      isPaymentDetailViewOpen: false,
    });
    this.initModuleButtons();
  };
  setVendorInvoiceHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      // isShowSaveButton: true,
      isShowBackButton: false,
      isHistoryFormOpened: true,
      isInvoiceLinesDetailsFormOpened: false,
      isEntryFormOpen: false,
      isPaymentDetailViewOpen: false,
    });
    this.initModuleButtons();
  };
  setPaymentDetailView = () => {
    this.closeAllNodeViews();
    this.setState({
      // isShowSaveButton: true,
      isShowBackButton: false,
      isHistoryFormOpened: true,
      isInvoiceLinesDetailsFormOpened: false,
      isEntryFormOpen: false,
      isPaymentDetailViewOpen: true,
    });
    this.initModuleButtons();
  };
  closeAllNodeViews = () => {
    this.setState({
      isShowSaveButton: false,
      isEntryFormOpen: false,
      isListFormOpen: false,
      isHistoryFormOpened: false,
      isInvoiceLinesDetailsFormOpened: false,
      isPaymentDetailViewOpen: false,
    });
  };
  onChange = (e) => {
    let temp_vendorInvoiceData = this.state.vendorInvoiceData;
    temp_vendorInvoiceData[e.target.name] = e.target.value;

    if (e.target.name === "toleranceForMatchingPercentage") {
      temp_vendorInvoiceData["toleranceForMatchingPercentage"] = e.target.value;
    }
    {
      temp_vendorInvoiceData[e.target.name] = e.target.value;
    }
    this.setState({
      vendorInvoiceData: temp_vendorInvoiceData,
    });
  };
  save = () => {
    this.saveVendorInvoice();
  };
  validateVendorInvoiceData = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.vendorCode)) {
        let errMsg = "VendorCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.vendorInvoiceReferenceNumber)) {
        let errMsg = "Vendor Refference is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.originalVendorInvoiceAmount)) {
        let errMsg = "Original Vendor Amount is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.invoiceDueDate)) {
        let errMsg = "Invoice Due Date is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({ errorList: err_list });
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValid = true;
    }
    return isValid;
  };
  saveVendorInvoiceResponse = (response) => {
  this.setState({ isLoading: false, loadingText: "" });
    let isSuccess = this.handleResponse(response.data);
    if (isSuccess) {
      if (!isEmpty(response.data.vendorInvoice)) {
        if (!this.isLocked) {
          this.editVendorInvoice(response.data.vendorInvoice.code);
        } else {
          this.code = response.data.vendorInvoice.code;
          this.unlockVendorInvoice(response.data.vendorInvoice.code);
        }
      }
    }
  };
  saveVendorInvoiceError = (error) => {
    this.setState({ isLoading: false, loadingText: "" });
    ShowError("Error : " + error);
  };
  saveVendorInvoice = () => {
    let vendorInvoiceData = this.state.vendorInvoiceData;
    vendorInvoiceData.companyCode = this.companyCode;
    let isValid = false;
    isValid = this.validateVendorInvoiceData(vendorInvoiceData);
    if (isValid) {
      this.setState({ isLoading: true, loadingText: "Saving .." });
      if (vendorInvoiceData.isFetched) {
        if (
          vendorInvoiceData.status ==
          LogicConstants.VENDOR_INVOICE_UNAPPROVE_STATUS
        ) {
          if (SecurityAccessManager.VendorInvoiceEdit_IsAccessible()) {
            AccountPayableService.updateVendorInvoice(
              vendorInvoiceData,
              this.saveVendorInvoiceResponse,
              this.saveVendorInvoiceError
            );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);

            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
          }
        }
      } else {
        if (SecurityAccessManager.VendorInvoiceCreate_IsAccessible()) {
          AccountPayableService.createVendorInvoice(
            vendorInvoiceData,
            this.saveVendorInvoiceResponse,
            this.saveVendorInvoiceError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  approveVendorInvoiceResponse = (response) => {
    this.setState({ isLoading: false, loadingText: "" });
    let isSuccess = this.handleApproveResponse(response.data);
    if (isSuccess == true) {
      if (
        !isEmpty(response.data.mainOperationResponse) &&
        !isEmpty(response.data.mainOperationResponse.vendorInvoice)
      ) {
        let vendorInvoiceData =
          response.data.mainOperationResponse.vendorInvoice;
        this.setState({ vendorInvoiceData: vendorInvoiceData });

        this.editVendorInvoice(vendorInvoiceData.code);
        // if (!this.isLocked) {
        // } else {
        //   this.code = vendorInvoiceData.code;
        //   this.unlockVendorInvoice(vendorInvoiceData.code);
        // }
      }
    }
  };
  approveVendorInvoiceError = (error) => {
    ShowError("Error : " + error);
    this.setState({ isLoading: false });
  };
  approveVendorInvoice = (e) => {
    if (e.detail == 1) {
      this.setState({ isLoading: true, loadingText: "Approving .." });
      let vendorInvoiceData = this.state.vendorInvoiceData;
      vendorInvoiceData.companyCode = this.companyCode;
      let inputRequest = new RestVendorInvoiceRequest();
      inputRequest.companyCode = this.companyCode;
      inputRequest.vendorInvoiceBean = vendorInvoiceData;
      if (vendorInvoiceData.isFetched) {
        inputRequest.isLockRequired = true;
      } else {
        inputRequest.isLockRequired = false;
      }
      if (vendorInvoiceData.isFetched) {
        if (
          vendorInvoiceData.status ==
          LogicConstants.VENDOR_INVOICE_UNAPPROVE_STATUS
        ) {
          if (SecurityAccessManager.VendorInvoice_IsAccessible()) {
            AccountPayableService.updateAndApproveVendorInvoice(
              inputRequest,
              this.approveVendorInvoiceResponse,
              this.approveVendorInvoiceError
            );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);

            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
          }
        }
      } else {
        if (SecurityAccessManager.VendorInvoice_IsAccessible()) {
          AccountPayableService.createAndApproveVendorInvoice(
            inputRequest,
            this.approveVendorInvoiceResponse,
            this.approveVendorInvoiceError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  saveCancelVendorInvoice = () => {
    this.setState({ isLoading: true, loadingText: "Cancelling .." });
    let vendorInvoiceData = this.state.vendorInvoiceData;
    let inputRequest = new RestVendorInvoiceRequest();
    inputRequest.companyCode = this.companyCode;
    inputRequest.vendorInvoiceBean = vendorInvoiceData;
    inputRequest.reason = this.state.reasonData;
    inputRequest.isLockRequired = true;
    if (SecurityAccessManager.VendorInvoiceCancel_IsAccessible()) {
      AccountPayableService.cancelVendorInvoice(
        inputRequest,
        this.cancelVendorInvoiceResponse,
        this.cancelVendorInvoiceError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  cancelVendorInvoiceResponse = (response) => {
    this.setState({ isLoading: false, loadingText: "" });
    let isSuccess = this.handleResponse(response.data);
    if (isSuccess) {
      if (!isEmpty(response.data.vendorInvoice)) {
        let vendorInvoiceData = response.data.vendorInvoice;
        this.setState({ vendorInvoiceData: vendorInvoiceData });
        // this.unlockVendorInvoice(vendorInvoiceData.code);
        // this.editVendorInvoice(vendorInvoiceData.code);
        if (this.isLocked) {
          this.code = vendorInvoiceData.code;
          this.unlockVendorInvoice(vendorInvoiceData.code);
        }
      }
    }
  };
  cancelVendorInvoiceError = (error) => {
    ShowError("Error : " + error);
    this.setState({ isLoading: false, loadingText: "" });
  };
  onReasonDescChange = (e) => {
    let reasonData = this.state.reasonData;
    reasonData[e.target.name] = e.target.value;
    this.setState({ reasonData: reasonData });
  };
  onReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        reasonData: reason,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.cancelReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readReasonBySearchString(searchString) {
    let reasonData = this.state.cancelReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.cancelReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };
  closeReasonModelCallBack = () => {
    this.setState({
      isShowCancelReasonPopup: false,
      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };
  openReasonCapture = (type) => {
    if (type === 1) {
      this.setState({
        isShowCancelReasonPopup: true,
      });
    } else if (type === 2) {
      this.setState({
        isShowUnApproveReasonPopup: true,
      });
    }
    this.setState({
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };
  onCancelReasonContinue = () => {
    this.saveCancelVendorInvoice();
    this.closeReasonModelCallBack();
  };
  cancelVendorInvoice = (e) => {
    if (e.detail == 1) this.openReasonCapture(1);
  };
  editVendorInvoiceResponse = (response) => {
    if (response.data != null) {
      let errMsg = "";
      if (response.data.lockResponse != null) {
        if (!isEmpty(response.data.lockResponse.errors)) {
          this.showErrorMessage(response.data.lockResponse);
          this.state.isViewMode = true;
        }
      }
      if (response.data.mainOperationResponse != null) {
        if (response.data.mainOperationResponse.errors != null) {
          response.data.mainOperationResponse.errors.map((err) => {
            errMsg = err.messageDescription;
          });
        }
      }
      if (response.data.additionalOperationResponse != null) {
        if (response.data.additionalOperationResponse.errors != null) {
          response.data.additionalOperationResponse.errors.map((err) => {
            errMsg = err.messageDescription;
          });
        }
      }
      if (response.data.mainOperationResponse != null) {
        if (
          errMsg !=
          "Vendor Invoice Code [" + this.state.moduleKeyCode + "] Not Read "
        ) {
          this.showErrorMessage(response.data.mainOperationResponse);
        }
      }
      if (response.data.dependenciesResponse != null) {
        if (response.data.dependenciesResponse.dependenciesBean != null) {
          if (
            response.data.dependenciesResponse.dependenciesBean
              .vendorShipVias != null
          ) {
            let vendorShipVias =
              response.data.dependenciesResponse.dependenciesBean
                .vendorShipVias;
            this.setState({
              vendorShipVias: vendorShipVias,
            });
          }
          if (
            response.data.dependenciesResponse.dependenciesBean.vendorTerms !=
            null
          ) {
            let vendorTerms =
              response.data.dependenciesResponse.dependenciesBean.vendorTerms;
            this.setState({
              vendorTerms: vendorTerms,
            });
          }
        }
      }
      if (response.data.mainOperationResponse != null) {
        let vendorInvoice = new VendorInvoiceBean();
        vendorInvoice = response.data.mainOperationResponse.vendorInvoice;
        if (vendorInvoice != null) {
          if (vendorInvoice.invoicePurchaseOrders != null) {
            let invPurchaseOrders = vendorInvoice.invoicePurchaseOrders;
            const sortedList = [...invPurchaseOrders].sort((a, b) => {
              if (a["lineNumber"] === null) return 1;
              if (b["lineNumber"] === null) return -1;
              if (a["lineNumber"] === null && b["lineNumber"] === null)
                return 0;
              return (
                a["lineNumber"]
                  .toString()
                  .localeCompare(b["lineNumber"].toString(), "en", {
                    numeric: true,
                  }) * 1
              );
            });
            vendorInvoice.invoicePurchaseOrders = sortedList;
          }
        }
        let isDisableFields = false;
         let isDisableFieldUnApprove = true;
        let pageTitle = this.state.moduleCaption + " - EDIT";
        if (vendorInvoice !== null) {
          let moduleKeyCode = vendorInvoice.code;
          if (
            vendorInvoice.orderStatus ==
            LogicConstants.VENDOR_INVOICE_CANCEL_STATUS
          ) {
            isDisableFields = true;
            pageTitle = this.state.moduleCaption + " - VIEW";
          }
          if (vendorInvoice.isFetched) isDisableFields = true;
          this.state.vendorInvoiceData = vendorInvoice;
          this.setState({
            vendorInvoiceData: vendorInvoice,
            pageTitle: pageTitle,
            isDisableFields: isDisableFields,
            isShowNodes: true,
            moduleKeyCode: moduleKeyCode,
             isDisableFieldUnApprove: isDisableFieldUnApprove,
          });
          this.isLocked = true;
          this.getNodeList();
          this.openEntryForm();
        } else {
          this.addNewEntry();
        }
      }
    }
    this.setState({ isLoading: false });
  };
  editVendorInvoiceError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : ", error);
  };
  editVendorInvoice = (vendorInvoiceCode) => {
    this.setState({
      isLoading: true,
    });
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = vendorInvoiceCode;
    let isLockRequired = NEW_ENTRY === vendorInvoiceCode ? false : true;
    readrestInput.isLockRequired = isLockRequired;
    // this.setState({
    //   disabled: true,
    // });
    if (SecurityAccessManager.VendorInvoiceView_IsAccessible()) {
      AccountPayableService.initVendorInvoiceModule(
        readrestInput,
        this.editVendorInvoiceResponse,
        this.editVendorInvoiceError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadVendorInvoice();
  };
  onMiscellaneousDetailsLoad = (e, row) => {
    this.setState({ vendorInvoiceMiscellaneousAmountDetailsData: row });
  };
  openEntryForm = () => {
    this.getNodeList();
    this.setState({
      isListFormOpen: false,
      isEntryFormOpen: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: false,
      isShowPDFReportButton: true,
      isShowApproveButton: false,
      isShowUnApproveButton: false,
      isShowCancelButton: false,
      isShowModuleSearchContainer: true,
      isShowNodes: true,
      isResetView: false,
      isShowAutoCompleteExpenseTypeList: false,
      expenseTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteExpenseSubTypeList: false,
      expenseSubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCurrencyList: false,
      currencyPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteMiscreasonList: false,
      miscReasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteAdjReasonList: false,
      adjReasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteVendorList: false,
      vendorPageListForAutoCompleteList: new Array(),
      isShowAutoCompletePoList: false,
      poPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteMiscPoList: false,
      MiscPoPageListForAutoCompleteList: new Array(),
      isShowSavebutton: true,
        isShowVendorInvoiceTypeLookUp: true,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isListFormOpen: false,
        disabled: false,
        isDisableNodeFields: false,
        isDisabledFields: false,
        isDisableFields: false,
           isVendorInvoiceTypeDisabled: false,
      });
      if (this.state.isViewMode) {
        let pageTitle = this.moduleCaption + " - VIEW";
        this.setState({
          isDisabledFields: true,
          isDisableFields: true,
          disabled: true,
          pageTitle: pageTitle,
          isVendorInvoiceTypeDisabled: true,
        });
      }
    } else {
      this.setState({
        isDisabledFields: true,
        isDisableFields: true,
        disabled: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    this.initModuleButtons();
  };
  initModuleButtons = () => {
    let vendorInvoiceData = this.state.vendorInvoiceData;
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let status = ModuleUtils.getVendorInvoiceStatusCaption(
      this.state.vendorInvoiceData.status
    );
    if (status !== undefined && status !== null) {
      moduleOrderStatus = status;
    }
    this.setState({ moduleOrderStatus: status });
    if (
      vendorInvoiceData.status == LogicConstants.VENDOR_INVOICE_UNAPPROVE_STATUS
    ) {
      this.setState({
        isShowApproveButton: true,
        isShowCancelButton: true,
        isDisableFields: false,
        isShowSaveButton: true,
        isDisabledFields: true,
         isVendorInvoiceTypeDisabled: true,
      });
    } else if (
      vendorInvoiceData.status == LogicConstants.VENDOR_INVOICE_APPROVE_STATUS
    ) {
      this.setState({
        isShowApproveButton: false,
        isShowUnApproveButton: true,
        isShowCancelButton: true,
        isShowSaveButton: false,
        isDisableFields: true,
        isDisabledFields: true,
      });
    } else if (
      vendorInvoiceData.status == LogicConstants.VENDOR_INVOICE_CANCEL_STATUS
    ) {
      this.setState({
        isShowApproveButton: false,
        isShowCancelButton: false,
        isShowUnApproveButton: false,
        isShowSaveButton: false,
        isDisableFields: true,
        isDisabledFields: true,
      });
    } else if (
      vendorInvoiceData.status == LogicConstants.VENDOR_INVOICE_PAID_STATUS
    ) {
      this.setState({
        isShowApproveButton: false,
        isShowCancelButton: true,
        isShowUnApproveButton: false,
        isShowSaveButton: false,
        isDisableFields: true,
        isDisabledFields: true,
      });
    } else if (
      vendorInvoiceData.status == LogicConstants.VENDOR_INVOICE_OPEN_STATUS
    ) {
      this.setState({
        isShowApproveButton: true,
        isShowCancelButton: false,
        isShowUnApproveButton: false,
        isShowSaveButton: true,
        isDisableFields: false,
        isDisabledFields: true,
      });
    } else if (
      vendorInvoiceData.status ==
      LogicConstants.VENDOR_INVOICE_PARTIALLY_PAID_STATUS
    ) {
      this.setState({
        isShowApproveButton: false,
        isShowCancelButton: true,
        isShowUnApproveButton: false,
        isShowSaveButton: true,
        isDisableFields: false,
        isDisabledFields: true,
      });
    }
    if (this.state.isViewMode) {
      this.setState({
        isDisabledFields: true,
        isDisableFields: true,
        disabled: true,
      });
    }
  };
  getListView() {
    return (
      <VendorListForm
        {...this.state}
        filterVendorInvoice={this.filterVendorInvoice}
        loadFirst={this.loadFirst}
        loadNext={this.loadNext}
        loadPrevious={this.loadPrevious}
        loadLast={this.loadLast}
        editVendorInvoice={this.editVendorInvoice}
        resetFilteredVendorInvoice={this.resetFilteredVendorInvoice}
        onCriteriaChange={this.onCriteriaChange}
        getHeaderView={this.getHeaderView}
        handleSortingChange={this.handleSortingChange}
      />
    );
  }
  getHeaderView() {
    return (
      <VendorInvoiceEntryForm
        {...this.state}
        onMiscellaneousDetailsLoad={this.onMiscellaneousDetailsLoad}
        onAdjustmentChange={this.onAdjustmentChange}
        onMiscellaneousChange={this.onMiscellaneousChange}
        addOrUpdate_Adj_Reason={this.addOrUpdate_Adj_Reason}
        addOrUpdate_Miscellaneous={this.addOrUpdate_Miscellaneous}
        saveVendorPurchaseOrderLine={this.saveVendorPurchaseOrderLine}
        getAdjustmentLineDetails={this.getAdjustmentLineDetails}
        getMiscLineDetails={this.getMiscLineDetails}
        adjReasonRef={this.adjReasonRef}
        adjAmountRef={this.adjAmountRef}
        miscReasonRef={this.miscReasonRef}
        miscReasonDescRef={this.miscReasonDescRef}
        miscAmountRef={this.miscAmountRef}
        miscPORef={this.miscPORef}
        miscRemarksRef={this.miscRemarksRef}
        poLineRef={this.poLineRef}
        poPurchaseOrderRef={this.poPurchaseOrderRef}
        poOrderDateRef={this.poOrderDateRef}
        poOrderStopDateRef={this.poOrderStopDateRef}
        poReceiptsRef={this.poReceiptsRef}
        clearAdjLineValues={this.clearAdjLineValues}
        clearMiscLineValues={this.clearMiscLineValues}
        clearPOLineValues={this.clearPOLineValues}
        onChange={this.onChange}
        onPurchaseOrderChange={this.onPurchaseOrderChange}
        loadVendorInvoiceLinesResponse={this.loadVendorInvoiceLinesResponse}
        loadVendorInvoiceLinesError={this.loadVendorInvoiceLinesError}
        vendorCodeOnChange={this.vendorCodeOnChange}
        vendorCodeEnterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
        displayVendorAutoCompleteList={this.displayVendorAutoCompleteList}
        deleteMiscLines={this.deleteMiscLines}
        deletePoLines={this.deletePoLines}
        deleteAdjLines={this.deleteAdjLines}
        onCheckBoxClick={this.onCheckBoxClick}
        onselectableRowSelected={this.onselectableRowSelected}
        openMiscPopup={this.openMiscPopup}
        openPOPopup={this.openPOPopup}
        openAdjPopup={this.openAdjPopup}
        hideAlertCallBacklvl3={this.hideAlertCallBacklvl3}
        closeAlertModalCallBacklvl3={this.closeAlertModalCallBacklvl3}
        closeAlertModalCallBacklvl5={this.closeAlertModalCallBacklvl5}
        hideAlertCallBackLvl5={this.hideAlertCallBackLvl5}
        showReceiptsLines={this.showReceiptsLines}
        lnkPOModule={this.lnkPOModule}
        closeModalCallBack={this.closeModalCallBack}
        onPurchaseOrderLineChange={this.onPurchaseOrderLineChange}
        selectPurchaseReceipt={this.selectPurchaseReceipt}
        unSelectPurchaseReceipt={this.unSelectPurchaseReceipt}
        addPoReceipts={this.addPoReceipts}
        handlePoLineNumberClick={this.handlePoLineNumberClick}
        expenseTypeOnChange={this.expenseTypeOnChange}
        expenseTypeEnterKeyEvent={this.expenseTypeEnterKeyEvent}
        displayExpenseTypeAutoCompleteList={
          this.displayExpenseTypeAutoCompleteList
        }
        expenseSubTypeOnChange={this.expenseSubTypeOnChange}
        expenseSubTypeEnterKeyEvent={this.expenseSubTypeEnterKeyEvent}
        displayExpenseSubTypeAutoCompleteList={
          this.displayExpenseSubTypeAutoCompleteList
        }
        currencyOnChange={this.currencyOnChange}
        currencyEnterKeyEvent={this.currencyEnterKeyEvent}
        displayCurrencyAutoCompleteList={this.displayCurrencyAutoCompleteList}
        miscReasonOnChange={this.miscReasonOnChange}
        miscReasonEnterKeyEvent={this.miscReasonEnterKeyEvent}
        displayMiscReasonAutoCompleteList={
          this.displayMiscReasonAutoCompleteList
        }
        adjReasonOnChange={this.adjReasonOnChange}
        adjReasonEnterKeyEvent={this.adjReasonEnterKeyEvent}
        displayAdjReasonAutoCompleteList={this.displayAdjReasonAutoCompleteList}
        purchaseOrderOnChange={this.purchaseOrderOnChange}
        poEnterKeyEventHandler={this.poEnterKeyEventHandler}
        displayPoAutoCompleteList={this.displayPoAutoCompleteList}
        MiscPurchaseOrderOnChange={this.MiscPurchaseOrderOnChange}
        MiscpoEnterKeyEventHandler={this.MiscpoEnterKeyEventHandler}
        displayMiscPoAutoCompleteList={this.displayMiscPoAutoCompleteList}
      />
    );
  }
  getInvoiceLinesView() {
    return (
      <InvoiceLinesDetailsForm
        {...this.state}
        save={this.save}
        clearError={this.clearError}
        saveVendorInvoice={this.saveVendorInvoice}
        onChange={this.onChange}
        onLineChange={this.onLineChange}
        saveVendorInvoiceLine={this.saveVendorInvoiceLine}
        addOrUpdate_Adj_Reason={this.addOrUpdate_Adj_Reason}
        clearInvoiceLineValues={this.clearInvoiceLineValues}
        openExcitingvendorInvoiceLineForm={
          this.openExcitingvendorInvoiceLineForm
        }
      />
    );
  }
  getHistoryView() {
    return <VendorInvoiceHistoryDetailsForm {...this.state} />;
  }
  getPaymentDetailView() {
    return (
      <VendorInvoicePaymentDetailsForm
        {...this.state}
        loadPaymentdetail={this.loadPaymentdetail}
      />
    );
  }
  loadVendorInvoiceLinesResponse = (response) => {
    let vendorInvoiceData = this.state.vendorInvoiceData;
    let resultData = response.data.invoiceLinesResult;
    let vendorInvoiceLines = resultData.invoiceLines;
    if (vendorInvoiceLines != null) {
      vendorInvoiceLines.map((line) => {
        if (vendorInvoiceData.invoiceLines != null) {
          let lineNumber = this.getvendorInvoiceLineMaxLineNumber();
          line.lineNumber = ++lineNumber;
          line.vendorInvoiceCode = this.state.vendorInvoiceData.code;
          if (line.currencyCode == null) {
            line.currencyCode = "CNY";
          } else if (line.currencyCode.trim() == "") {
            line.currencyCode = "CNY";
          }
          if (line.extraChargeAmount == null) {
            line.extraChargeAmount = 0;
          }
          if (line.discountAmount == null) {
            line.discountAmount = 0;
          }
          if (line.invoiceQuantity == null) {
            line.invoiceQuantity = 0;
          }
        }
        vendorInvoiceData.invoiceLines.push(line);
      });
    }
    this.calculateTotal();
    this.setState({
      vendorInvoiceData: vendorInvoiceData,
    });
  };
  calculateTotal() {
    let vendorInvoiceData = this.state.vendorInvoiceData;
    let totalMerchAmt = 0;
    if (vendorInvoiceData.invoiceLines != null) {
      vendorInvoiceData.invoiceLines.map((line) => {
        totalMerchAmt = parseFloat(totalMerchAmt) + parseFloat(line.lineAmount);
      });
    }
    vendorInvoiceData.merchandiseAmount = totalMerchAmt;
    let totalMiscAmt = 0;
    if (vendorInvoiceData.miscellaneousAmountDetails != null) {
      vendorInvoiceData.miscellaneousAmountDetails.map((line) => {
        totalMiscAmt =
          parseFloat(totalMiscAmt) + parseFloat(line.miscellaneousAmount);
      });
    }
    let totalAdjAmt = 0;
    if (vendorInvoiceData.adjustmentAmounts != null) {
      vendorInvoiceData.adjustmentAmounts.map((line) => {
        totalAdjAmt =
          parseFloat(totalAdjAmt) + parseFloat(line.adjustmentAmount);
      });
    }
    vendorInvoiceData.adjustmentAmount = totalAdjAmt;
    let totalGrandTotAmt = 0;
    totalGrandTotAmt =
      parseFloat(totalMerchAmt) +
      parseFloat(totalAdjAmt) +
      parseFloat(totalMiscAmt);
    vendorInvoiceData.grandTotalAmount =
      parseFloat(totalGrandTotAmt).toFixed(2);
    this.setState({
      vendorInvoiceData: vendorInvoiceData,
    });
  }
  loadVendorInvoiceLinesError = (error) => {
    ShowError("Error : ", error);
  };
  getvendorInvoiceLineMaxLineNumber() {
    let maxLineNumber = 0;
    let poLineFormData = this.state.vendorInvoiceData.invoiceLines;
    if (poLineFormData.length > 0)
      poLineFormData.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  loadPaymentdetail = () => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = this.state.vendorInvoiceData.code;
    if (SecurityAccessManager.VendorInvoice_IsAccessible()) {
      AccountPayableService.readCheckTransactionPaymentLinesForVendorInvoice(
        readrestInput,
        this.checkResponse,
        this.checkError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  checkResponse = (response) => {
    let paymentDetail =
      response.data.checkTransactionPaymentDetailPageList
        .checkTransactionPaymentDetails;
    if (!isEmptyArray(paymentDetail)) {
      this.setState({
        paymentDetail: paymentDetail,
        isPaymentDetailsDatasFound: true,
      });
      this.loadDatas(paymentDetail);
    }
  };
  checkError = (error) => {};
  loadDatas = (paymentDetail) => {
    let paymentDetailList = new Array();
    if (isEmptyArray(this.state.paymentDetailList)) {
      paymentDetailList = this.state.paymentDetailList;
      let runningBalanceAmount = this.state.vendorInvoiceData.grandTotalAmount;
      paymentDetail.map((ln) => {
        let paymentDetailData = new CheckTransactionPaymentDetailBean();
        let lineStatus = "";
        if (ln.applied == true) {
          lineStatus = "Posted";
        }
        paymentDetailData.checkTransactionNumber = ln.checkTransactionNumber;
        paymentDetailData.paymentType = ln.paymentType;
        paymentDetailData.documentNumber = ln.documentNumber;
        paymentDetailData.paymentAmount = ln.paymentAmount;
        paymentDetailData.paymentDate = ln.paymentDate;
        paymentDetailData.paymentPostDate = ln.paymentPostDate;
        runningBalanceAmount -= ln.paymentAmount;
        paymentDetailData.amountDue = runningBalanceAmount;
        if (paymentDetailData.amountDue < 0) {
          paymentDetailData.amountDue = 0;
        }
        if (ln.applied == true) {
          let lineStatus = "Posted";
          paymentDetailData.status = lineStatus;
        }

        paymentDetailList.push(paymentDetailData);
      });
    }

    // for (let list of paymentDetail) {
    //   let paymentDetailData = new CheckTransactionPaymentDetailBean();
    //   let lineStatus = "";
    //   if (list.applied == true) {
    //     lineStatus = "Posted";
    //   }
    //   paymentDetailData.checkTransactionNumber = list.checkTransactionNumber;
    //   paymentDetailData.paymentType = list.paymentType;
    //   paymentDetailData.documentNumber = list.documentNumber;
    //   paymentDetailData.paymentAmount = list.paymentAmount;
    //   paymentDetailData.paymentDate = list.paymentDate;
    //   paymentDetailData.paymentPostDate = list.paymentPostDate;
    //   runningBalanceAmount -= list.paymentAmount;
    //   paymentDetailData.amountDue = runningBalanceAmount;
    //   if (paymentDetailData.amountDue < 0) {
    //     paymentDetailData.amountDue = 0;
    //   }
    //   if (list.applied == true) {
    //     let lineStatus = "Posted";
    //     paymentDetailData.status = lineStatus;
    //   }
    //   paymentDetailList.push(paymentDetailData);
    // }
    this.setState({
      paymentDetailList: paymentDetailList,
    });
  };
  onPurchaseOrderLineChange = (e) => {
    let temp_vendorInvoiceData = this.state.vendorInvoiceData;
    temp_vendorInvoiceData[e.target.name] = e.target.value;
    let temp_vendorInvoicePurchaseOrderData =
      this.state.vendorInvoicePurchaseOrderData;
    temp_vendorInvoicePurchaseOrderData[e.target.name] = e.target.value;
    if (e.target.name == "purchaseOrderNumber") {
      if (e.target.value != null) {
        this.readPurchaseOrder(e.target.value);
      }
    }
    this.setState({
      vendorInvoicePurchaseOrderData: temp_vendorInvoicePurchaseOrderData,
    });
  };
  readPurchaseOrder = (purchaseOrderCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = purchaseOrderCode;
    if (SecurityAccessManager.VendorInvoice_IsAccessible()) {
      PurchaseOrderService.readPurchaseOrder(
        readrestInput,
        this.readPurchaseOrderResponse,
        this.readPurchaseOrderError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readPurchaseOrderResponse = (response) => {
    let poBean = response.data.purchaseOrder;
    if (poBean != null) {
      let purchaseOrderData = new VendorInvoicePurchaseOrderBean();
      purchaseOrderData.companyCode = this.companyCode;
      purchaseOrderData.purchaseOrderNumber = poBean.code;
      purchaseOrderData.purchaseOrderDate = poBean.orderStartDate;
      purchaseOrderData.purchaseOrderStopDate = poBean.orderStopDate;
      purchaseOrderData.vendorInvoiceCode = this.state.vendorInvoiceData.code;
      this.setState({
        vendorInvoicePurchaseOrderData: purchaseOrderData,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readPurchaseOrderError = (error) => {
    ShowError("Error : ", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  getPurchaseReceipts = (code) => {
    let searchCriteria = new PurchaseOrderReceiptSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.purchaseOrderNumber = code;
    let pageList = new RestPageListBean();
    pageList.pageSize = 50;
    let requestInput = new RestPurchaseOrderReceiptListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = searchCriteria;
    if (SecurityAccessManager.VendorInvoice_IsAccessible()) {
      PurchaseOrderReceiptService.getPurchaseOrderReceiptPageList(
        requestInput,
        this.loadPurchaseReceiptLinesResponse,
        this.loadPurchaseReceiptLinesError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPurchaseReceiptLinesResponse = (response) => {
    if (
      response.data != null &&
      response.data.purchaseOrderReceiptPageList != null &&
      response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts != null
    ) {
      let purchaseReceiptsListData =
        response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts;
      let poReceipts = [];
      let sampleReceipts = [];
      purchaseReceiptsListData.map((ln) => {
        poReceipts.push(ln);
        sampleReceipts.push(ln);
      });
      if (!isEmptyArray(this.state.receipts)) {
        let selectedReceipts = [];
        let availableReceipts = [];
        this.state.receipts.map((ln) => {
          poReceipts.map((pr) => {
            if (ln == pr.code) {
              selectedReceipts.push(pr);
            }
          });
        });
        if (!isEmptyArray(selectedReceipts)) {
          availableReceipts.push(...sampleReceipts);
          selectedReceipts.map((sr) => {
            availableReceipts.map((ln, i) => {
              if (sr.code == ln.code) {
                availableReceipts.splice(i, 1);
              }
            });
          });
        }
        this.setState({
          selectedReceipts: selectedReceipts,
          availableReceipts: availableReceipts,
        });
      } else {
        this.setState({
          purchaseOrderReceipts: purchaseReceiptsListData,
          availableReceipts: poReceipts,
          purchaseReceipts: purchaseReceiptsListData,
        });
      }
    }
  };
  loadPurchaseReceiptLinesError = (error) => {
    ShowError("Error : ", error);
  };
  onCheckBoxClick = (e) => {
    let selectedRows = e.selectedRows;
    this.setState({
      selectedInvoiceLines: selectedRows,
    });
  };
  onselectableRowSelected = (row) => {
    let selectedInvoiceLines = this.state.selectedInvoiceLines;
    let isRowSelected = false;
    if (selectedInvoiceLines) {
      selectedInvoiceLines.map((line) => {
        if (line.purchaseReceiptNumber == row.purchaseReceiptNumber) {
          isRowSelected = true;
        }
      });
    }
    return isRowSelected;
  };
  onLineChange = (e) => {
    let temp_vendorInvoiceLineData = this.state.vendorInvoiceLineData;
    temp_vendorInvoiceLineData[e.target.name] = e.target.value;
    this.setState({ vendorInvoiceLineData: temp_vendorInvoiceLineData });
  };
  openExcitingvendorInvoiceLineForm = (rowData) => {
    let venInvoiceLineData = { ...rowData };
    venInvoiceLineData.code = this.state.vendorInvoiceData.code;

    let newvendorInvoiceLineData = new VendorInvoiceLineBean();
    newvendorInvoiceLineData = venInvoiceLineData;

    this.setState({
      vendorInvoiceLineData: newvendorInvoiceLineData,
      isDisabledFields: false,
    });
  };
  clearInvoiceLineValues = () => {
    let newLineBean = new VendorInvoiceLineBean();
    this.setState({
      vendorInvoiceLineData: newLineBean,
      isDisabledFields: true,
    });
    this.setGrandTotalAmount();
  };
  setGrandTotalAmount = () => {
    let vendorInvoiceData = this.state.vendorInvoiceData;
    let totalMerchAmt = 0;
    let miscellaneousAmount = 0;
    if (
      vendorInvoiceData.invoiceLines != null ||
      !isEmptyArray(vendorInvoiceData.invoiceLines)
    ) {
      vendorInvoiceData.invoiceLines.map((line) => {
        totalMerchAmt = parseFloat(totalMerchAmt) + parseFloat(line.lineAmount);
      });
    }
    if (
      vendorInvoiceData.miscellaneousAmountDetails != null ||
      !isEmptyArray(vendorInvoiceData.miscellaneousAmountDetails)
    ) {
      vendorInvoiceData.miscellaneousAmountDetails.map((line) => {
        miscellaneousAmount += parseFloat(line.miscellaneousAmount);
      });
    }
    vendorInvoiceData.merchandiseAmount = totalMerchAmt;
    vendorInvoiceData.grandTotalAmount =
      totalMerchAmt + miscellaneousAmount + vendorInvoiceData.adjustmentAmount;
    vendorInvoiceData.grandTotalAmount = parseFloat(
      vendorInvoiceData.grandTotalAmount
    ).toFixed(2);
    this.setState({ vendorInvoiceData: vendorInvoiceData });
  };
  selectPurchaseReceipt = (e, value, rowData) => {
    if (e.detail == 1) {
      let availableReceipts = this.state.availableReceipts;
      let selectedReceipts = this.state.selectedReceipts;
      availableReceipts.map((ln, i) => {
        if (ln.code === value) {
          selectedReceipts.push(ln);
          availableReceipts.splice(i, 1);
        }
      });
      this.setState({
        availableReceipts: availableReceipts,
        selectedReceipts: selectedReceipts,
      });
    }
  };
  unSelectPurchaseReceipt = (e, value, rowData) => {
    if (e.detail == 1) {
      let availableReceipts = this.state.availableReceipts;
      let selectedReceipts = this.state.selectedReceipts;
      selectedReceipts.map((ln, i) => {
        if (ln.code === value) {
          availableReceipts.push(ln);
          selectedReceipts.splice(i, 1);
        }
      });
      this.setState({
        availableReceipts: availableReceipts,
        selectedReceipts: selectedReceipts,
      });
    }
  };
  addPoReceipts = (e) => {
    if (e.detail == 1) {
      let selectedReceipts = this.state.selectedReceipts;
      let vendorInvoicePurchaseOrderData =
        this.state.vendorInvoicePurchaseOrderData;
      let receipts = [];
      let PoReceipts = [];
      selectedReceipts.map((ln) => {
        receipts.push(ln.code);
        let receiptBean = new VendorInvoicePurchaseOrderReceiptBean();
        receiptBean.companyCode = this.companyCode;
        receiptBean.vendorInvoicePOLineNumber =
          vendorInvoicePurchaseOrderData.lineNumber;
        receiptBean.purchaseReceiptNumber = ln.code;
        receiptBean.vendorInvoiceCode = this.state.vendorInvoiceData.code;
        receiptBean.purchaseReceiptNumber = ln.code;
        receiptBean.purchaseReceiptDate = ln.receiptDate;
        receiptBean.purchaseOrderNumber = ln.purchaseOrderNumber;
        PoReceipts.push(receiptBean);
      });
      vendorInvoicePurchaseOrderData.purchaseReceipts = [];
      vendorInvoicePurchaseOrderData.purchaseReceipts.push(...PoReceipts);
      this.setState({
        receipts: receipts,
        vendorInvoicePurchaseOrderData: vendorInvoicePurchaseOrderData,
      });
      this.closeAlertModalCallBacklvl3();
    }
  };
  lnkPOModule = (code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPurchaseOrderModule: true,
        moduleForPopup: (
          <PopupPurchaseOrderModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openMiscPopup = () => {
    this.setState({ isShowMiscPopup: true });
    setTimeout(() => {
      if (this.miscReasonRef.current != null) {
        this.miscReasonRef.current.focus();
      }
    }, 100);
  };
  openPOPopup = () => {
    this.setState({
      isShowPOPopup: true,
      isShowAutoCompletePoList: false,
      poPageListForAutoCompleteList: [],
    });
    setTimeout(() => {
      if (this.purchaseRef.current != null) {
        this.purchaseRef.current.focus();
      }
    }, 100);
  };
  openAdjPopup = () => {
    this.setState({
      isShowAdjustmentPopup: true,
    });
    setTimeout(() => {
      if (this.adjReasonRef.current != null) {
        this.adjReasonRef.current.focus();
      }
    }, 100);
  };
  showReceiptsLines = (e) => {
    if (e.detail == 1) {
      let poData = this.state.vendorInvoicePurchaseOrderData;
      if (!isEmptyString(poData.purchaseOrderNumber)) {
        this.getPurchaseReceipts(poData.purchaseOrderNumber);
      }
      this.setState({
        isShowReceiptsPopup: true,
      });
    }
  };
  expenseTypeOnChange = (e) => {
    let expenseType = e.target.value;
    this.state.isShowAutoCompleteExpenseTypeList = true;
    let tempData = this.state.vendorInvoiceData;
    let showAutoCompleteList = this.state.isShowAutoCompleteExpenseTypeList;
    if (isEmpty(expenseType)) {
      this.state.isShowAutoCompleteExpenseTypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteExpenseTypeList;
      let tempData = this.state.vendorInvoiceData;
      tempData.expenseType = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        vendorInvoiceData: tempData,
        expenseTypePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "expenseType" &&
      showAutoCompleteList === true &&
      expenseType !== ""
    ) {
      this.readExpenseTypeBySearchString(e.target.value);
      this.readExpenseType(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ vendorInvoiceData: tempData });
  };
  expenseTypeEnterKeyEvent = (e) => {
    this.readExpenseType(e.target.value);
    this.state.isShowAutoCompleteExpenseTypeList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteExpenseTypeList;
    this.setState({
      expenseTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayExpenseTypeAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteExpenseTypeList: isShowAutoCompleteList,
    });
  };
  readExpenseTypeBySearchString = (searchString) => {
    let expenseTypeData = this.state.expenseTypes;
    let simpleAutoCompleteList = new Array();
    if (expenseTypeData.length > 0 && expenseTypeData != null) {
      expenseTypeData.map((obj) => {
        let expenseTypeBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(expenseTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      expenseTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readExpenseType = (expenseType) => {
    let tempData = this.state.vendorInvoiceData;
    let expenseTypeBean = null;
    let expenseTypeData = null;
    this.state.expenseTypes.map((ln) => {
      if (ln.code === expenseType) {
        expenseTypeBean = ln;
        expenseTypeData = new BaseBean();
        expenseTypeData.code = ln.code;
        expenseTypeData.description = ln.description;
      }
    });
    if (!isEmpty(expenseTypeBean)) {
      tempData.expenseType = expenseTypeBean.code;
      this.state.isShowAutoCompleteExpenseTypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteExpenseTypeList;
      this.setState({
        vendorInvoiceData: tempData,
        isShowAutoCompleteExpenseTypeList: showAutoCompleteList,
      });
    }
  };
  expenseSubTypeOnChange = (e) => {
    let ExpenseSubType = e.target.value;
    this.state.isShowAutoCompleteExpenseSubTypeList = true;
    let tempData = this.state.vendorInvoiceData;
    let showAutoCompleteList = this.state.isShowAutoCompleteExpenseSubTypeList;
    if (isEmpty(ExpenseSubType)) {
      this.state.isShowAutoCompleteExpenseSubTypeList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteExpenseSubTypeList;
      let tempData = this.state.vendorInvoiceData;
      tempData.ExpenseSubType = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        vendorInvoiceData: tempData,
        expenseSubTypePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "expenseSubType" &&
      showAutoCompleteList === true &&
      ExpenseSubType !== ""
    ) {
      this.readExpenseSubTypeBySearchString(e.target.value);
      this.readExpenseSubType(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ vendorInvoiceData: tempData });
  };
  expenseSubTypeEnterKeyEvent = (e) => {
    this.readExpenseSubType(e.target.value);
    this.state.isShowAutoCompleteExpenseSubTypeList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteExpenseSubTypeList;
    this.setState({
      expenseSubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayExpenseSubTypeAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteExpenseSubTypeList: isShowAutoCompleteList,
    });
  };
  readExpenseSubTypeBySearchString = (searchString) => {
    let expenseSubTypeData = this.state.expenseSubTypes;
    let simpleAutoCompleteList = new Array();
    if (expenseSubTypeData.length > 0 && expenseSubTypeData != null) {
      expenseSubTypeData.map((obj) => {
        let expenseSubTypeBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(expenseSubTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      expenseSubTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readExpenseSubType = (ExpenseSubType) => {
    let tempData = this.state.vendorInvoiceData;
    let expenseSubTypeBean = null;
    let expenseSubTypeData = null;
    this.state.expenseSubTypes.map((ln) => {
      if (ln.code === ExpenseSubType) {
        expenseSubTypeBean = ln;
        expenseSubTypeData = new BaseBean();
        expenseSubTypeData.code = ln.code;
        expenseSubTypeData.description = ln.description;
      }
    });
    if (!isEmpty(expenseSubTypeBean)) {
      tempData.expenseSubType = expenseSubTypeBean.code;
      this.state.isShowAutoCompleteExpenseSubTypeList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteExpenseSubTypeList;
      this.setState({
        vendorInvoiceData: tempData,
        isShowAutoCompleteExpenseSubTypeList: showAutoCompleteList,
      });
    }
  };
  currencyOnChange = (e) => {
    let currencyCode = e.target.value;
    this.state.isShowAutoCompleteCurrencyList = true;
    let tempData = this.state.vendorInvoiceData;
    let showAutoCompleteList = this.state.isShowAutoCompleteCurrencyList;
    if (isEmpty(currencyCode)) {
      this.state.isShowAutoCompleteCurrencyList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCurrencyList;
      let tempData = this.state.vendorInvoiceData;
      tempData.currencyCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        vendorInvoiceData: tempData,
        currencyPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "currencyCode" &&
      showAutoCompleteList === true &&
      currencyCode !== ""
    ) {
      this.readCurrencyBySearchString(e.target.value);
      this.readCurrency(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ vendorInvoiceData: tempData });
  };
  currencyEnterKeyEvent = (e) => {
    this.readCurrency(e.target.value);
    this.state.isShowAutoCompleteCurrencyList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCurrencyList;
    this.setState({
      currencyPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayCurrencyAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCurrencyList: isShowAutoCompleteList,
    });
  };
  readCurrencyBySearchString = (searchString) => {
    let currencyData = this.state.currencies;
    let simpleAutoCompleteList = new Array();
    if (currencyData.length > 0 && currencyData != null) {
      currencyData.map((obj) => {
        let currencyBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(currencyBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      currencyPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readCurrency = (currencyCode) => {
    let tempData = this.state.vendorInvoiceData;
    let currencyBean = null;
    let currencyData = null;
    this.state.currencies.map((ln) => {
      if (ln.code === currencyCode) {
        currencyBean = ln;
        currencyData = new BaseBean();
        currencyData.code = ln.code;
        currencyData.description = ln.description;
      }
    });
    if (!isEmpty(currencyBean)) {
      tempData.currencyCode = currencyBean.code;
      this.state.isShowAutoCompleteCurrencyList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCurrencyList;
      this.setState({
        vendorInvoiceData: tempData,
        isShowAutoCompleteCurrencyList: showAutoCompleteList,
      });
    }
  };
  miscReasonOnChange = (e) => {
    let reasonCode = e.target.value;
    this.state.isShowAutoCompleteMiscreasonList = true;
    let tempData = this.state.vendorInvoiceMiscellaneousAmountDetailsData;
    let showAutoCompleteList = this.state.isShowAutoCompleteMiscreasonList;
    if (isEmpty(reasonCode)) {
      this.state.isShowAutoCompleteMiscreasonList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteMiscreasonList;
      let tempData = this.state.vendorInvoiceMiscellaneousAmountDetailsData;
      tempData.reasonCode = "";
      tempData.reasonDescription = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        vendorInvoiceMiscellaneousAmountDetailsData: tempData,
        miscReasonPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "reasonCode" &&
      showAutoCompleteList === true &&
      reasonCode !== ""
    ) {
      this.readMiscReasonBySearchString(e.target.value);
      this.readMiscReason(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ vendorInvoiceMiscellaneousAmountDetailsData: tempData });
  };
  miscReasonEnterKeyEvent = (e) => {
    this.readMiscReason(e.target.value);
    this.state.isShowAutoCompleteMiscreasonList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteMiscreasonList;
    this.setState({
      miscReasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayMiscReasonAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteMiscreasonList: isShowAutoCompleteList,
    });
  };
  readMiscReasonBySearchString = (searchString) => {
    let reasonData = this.state.vendorInvoiceMiscellaneousReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((obj) => {
        let reasonBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(reasonBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      miscReasonPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readMiscReason = (reasonCode) => {
    let tempData = this.state.vendorInvoiceMiscellaneousAmountDetailsData;
    let reasonBean = null;
    let reasonData = null;
    this.state.vendorInvoiceMiscellaneousReasons.map((ln) => {
      if (ln.code === reasonCode) {
        reasonBean = ln;
        reasonData = new BaseBean();
        reasonData.code = ln.code;
        reasonData.description = ln.description;
      }
    });
    if (!isEmpty(reasonBean)) {
      tempData.reasonCode = reasonBean.code;
      tempData.reasonDescription = reasonBean.description;
      this.state.isShowAutoCompleteMiscreasonList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteMiscreasonList;
      this.setState({
        vendorInvoiceMiscellaneousAmountDetailsData: tempData,
        isShowAutoCompleteMiscreasonList: showAutoCompleteList,
      });
    }
  };
  adjReasonOnChange = (e) => {
    let AdjustmentReason = e.target.value;
    this.state.isShowAutoCompleteAdjReasonList = true;
    let tempData = this.state.vendorInvoiceAdjustmentData;
    let showAutoCompleteList = this.state.isShowAutoCompleteAdjReasonList;
    if (isEmpty(AdjustmentReason)) {
      this.state.isShowAutoCompleteAdjReasonList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteAdjReasonList;
      let tempData = this.state.vendorInvoiceAdjustmentData;
      tempData.adjustmentReason = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        vendorInvoiceAdjustmentData: tempData,
        adjReasonPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "adjustmentReason" &&
      showAutoCompleteList === true &&
      AdjustmentReason !== ""
    ) {
      this.readAdjReasonBySearchString(e.target.value);
      this.readAdjReason(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ vendorInvoiceAdjustmentData: tempData });
  };
  adjReasonEnterKeyEvent = (e) => {
    this.readAdjReason(e.target.value);
    this.state.isShowAutoCompleteAdjReasonList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteAdjReasonList;
    this.setState({
      adjReasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAdjReasonAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteAdjReasonList: isShowAutoCompleteList,
    });
  };
  readAdjReasonBySearchString = (searchString) => {
    let reasonData = this.state.vendorInvoiceAdjustmentReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((obj) => {
        let reasonBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(reasonBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      adjReasonPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readAdjReason = (AdjustmentReason) => {
    let tempData = this.state.vendorInvoiceAdjustmentData;
    let reasonBean = null;
    let reasonData = null;
    this.state.vendorInvoiceAdjustmentReasons.map((ln) => {
      if (ln.code === AdjustmentReason) {
        reasonBean = ln;
        reasonData = new BaseBean();
        reasonData.code = ln.code;
        reasonData.description = ln.description;
      }
    });
    if (!isEmpty(reasonBean)) {
      tempData.adjustmentReason = reasonBean.code;
      this.state.isShowAutoCompleteAdjReasonList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteAdjReasonList;
      this.setState({
        vendorInvoiceAdjustmentData: tempData,
        isShowAutoCompleteAdjReasonList: showAutoCompleteList,
      });
    }
  };
  vendorCodeOnChange = (e) => {
    let vendorCode = e.target.value;
    this.state.isShowAutoCompleteVendorList = true;
    let tempData = this.state.vendorInvoiceData;
    let showAutoCompleteList = this.state.isShowAutoCompleteVendorList;
    if (isEmpty(vendorCode)) {
      this.state.isShowAutoCompleteVendorList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteVendorList;
      let tempData = this.state.vendorInvoiceData;
      tempData.vendorCode = "";
      tempData.vendorName = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteVendorList: showAutoCompleteList,
        vendorInvoiceData: tempData,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      showAutoCompleteList === true &&
      vendorCode !== ""
    ) {
      this.readVendorBySearchString(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({
      vendorInvoiceData: tempData,
    });
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading Vendor",
    });
    this.readVendor(e.target.value);
    this.state.isShowAutoCompleteVendorList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteVendorList;
    this.setState({
      vendorPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteVendorList: showAutoCompleteList,
    });
  };
  displayVendorAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompleteVendorList: showAutoCompleteList });
  };
  readVendorBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.searchCriteria = searchCriteria;
    input.pageInput = pageList;
    VendorService.getVendorPageList(
      input,
      this.readByVendorCodeResponse,
      this.readByVendorCodeResponseError
    );
  }
  readByVendorCodeResponse = (response) => {
    let vendorCodeData = response.data.vendorPageList.vendors;
    let simpleAutoCompleteList = new Array();
    if (vendorCodeData.length > 0 && vendorCodeData != null) {
      vendorCodeData.map((vendorCode) => {
        let simpleItemBean = {
          code: vendorCode.code,
          description: vendorCode.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      vendorPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readByVendorCodeResponseError = (error) => {
    ShowError("Error : ", error);
  };
  readVendor = (vendorCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = vendorCode;
    readrestInput.isLoadChildren = true;
    if (SecurityAccessManager.VendorInvoice_IsAccessible()) {
      VendorService.initVendorModule(
        readrestInput,
        this.readVendorResponse,
        this.readVendorError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readVendorResponse = (response) => {
    let vendorData = response.data.vendorResponse.vendor;
    if (vendorData != null) {
      let vendorInvoiceData = this.state.vendorInvoiceData;
      vendorInvoiceData.vendorCode = vendorData.code;
      vendorInvoiceData.vendorName = vendorData.description;
      let purchaseOrderLookupHandler = new PurchaseOrderLookupHandler(
        this.companyCode,
        "PurchaseOrder",
        vendorData.code
      );
      this.setState({ purchaseorderLookupHandler: purchaseOrderLookupHandler });
      this.setState({
        vendorInvoiceData: vendorInvoiceData,
        isShowPOLookup: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readVendorError = (error) => {
    ShowError("Error : ", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  purchaseOrderOnChange = (e) => {
    let PurchaseOrderNumber = e.target.value;
    this.state.isShowAutoCompletePoList = true;
    let tempData = this.state.vendorInvoicePurchaseOrderData;
    let showAutoCompleteList = this.state.isShowAutoCompletePoList;
    if (isEmpty(PurchaseOrderNumber)) {
      this.state.isShowAutoCompletePoList = false;
      let showAutoCompleteList = this.state.isShowAutoCompletePoList;
      let tempData = this.state.vendorInvoicePurchaseOrderData;
      tempData.PurchaseOrderNumber = "";
      tempData.vendorInvoiceCode = "";
      tempData.purchaseOrderDate = "";
      tempData.purchaseOrderStopDate = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompletePoList: showAutoCompleteList,
        vendorInvoicePurchaseOrderData: tempData,
        poPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "purchaseOrderNumber" &&
      showAutoCompleteList === true &&
      PurchaseOrderNumber !== ""
    ) {
      this.readPOBySearchString(e.target.value);
      this.readPurchaseOrder(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({
      vendorInvoicePurchaseOrderData: tempData,
    });
  };
  poEnterKeyEventHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading PurchaseOrder",
    });
    this.readPurchaseOrder(e.target.value);
    this.state.isShowAutoCompletePoList = false;
    let showAutoCompleteList = this.state.isShowAutoCompletePoList;
    this.setState({
      poPageListForAutoCompleteList: new Array(),
      isShowAutoCompletePoList: showAutoCompleteList,
    });
  };
  readPOBySearchString(searchString) {
    let searchCriteria = new PurchaseOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.purchaseOrderNumberStartsWith = searchString;
    searchCriteria.purchaseOrderNumberContains = searchString;
    searchCriteria.vendorCode = this.state.vendorInvoiceData.vendorCode;
    searchCriteria.orderStatus = "R";
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestPurchaseOrderListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    PurchaseOrderService.getPurchaseOrderPageList(
      cust_requestInput,
      this.readPurchaseOrderBySearchStringResponse,
      this.readPurchaseOrderBySearchStringError
    );
  }
  readPurchaseOrderBySearchStringResponse = (response) => {
    let purchaseorderData = response.data.purchaseOrderPageList.purchaseOrders;
    let simpleAutoCompleteList = new Array();
    if (purchaseorderData.length > 0 && purchaseorderData != null) {
      purchaseorderData.map((po) => {
        let simpleItemBean = {
          code: po.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      poPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readPurchaseOrderBySearchStringError = (error) => {
    ShowError("Error : " + error);
  };
  displayPoAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompletePoList: showAutoCompleteList });
  };
  MiscPurchaseOrderOnChange = (e) => {
    let PurchaseOrderNumber = e.target.value;
    this.state.isShowAutoCompleteMiscPoList = true;
    let tempData = this.state.vendorInvoiceMiscellaneousAmountDetailsData;
    let showAutoCompleteList = this.state.isShowAutoCompleteMiscPoList;
    if (isEmpty(PurchaseOrderNumber)) {
      this.state.isShowAutoCompleteMiscPoList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteMiscPoList;
      let tempData = this.state.vendorInvoiceMiscellaneousAmountDetailsData;
      tempData.purchaseOrderNumber = "";
      tempData.vendorName = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteMiscPoList: showAutoCompleteList,
        vendorInvoiceMiscellaneousAmountDetailsData: tempData,
        MiscPoPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "purchaseOrderNumber" &&
      showAutoCompleteList === true &&
      PurchaseOrderNumber !== ""
    ) {
      this.readMiscPOBySearchString(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({
      vendorInvoiceMiscellaneousAmountDetailsData: tempData,
    });
  };
  MiscpoEnterKeyEventHandler = (e) => {
    this.state.isShowAutoCompleteMiscPoList = false;
    let MiscPoPageListForAutoCompleteList =
      this.state.MiscPoPageListForAutoCompleteList;
    let showAutoCompleteList = this.state.isShowAutoCompleteMiscPoList;
    this.readMiscPurchaseOrder(
      e.target.value,
      MiscPoPageListForAutoCompleteList
    );
    this.setState({
      MiscPoPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteMiscPoList: showAutoCompleteList,
    });
  };
  displayMiscPoAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompleteMiscPoList: showAutoCompleteList });
  };
  readMiscPurchaseOrder = (code, list) => {
    let tempData = this.state.vendorInvoiceMiscellaneousAmountDetailsData;
    let reasonBean = null;
    let reasonData = null;
    list.map((ln) => {
      if (ln.code === code) {
        reasonBean = ln;
      }
    });
    if (!isEmpty(reasonBean)) {
      tempData.purchaseOrderNumber = reasonBean.code;
      this.state.isShowAutoCompleteMiscPoList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteMiscPoList;
      this.setState({
        vendorInvoiceMiscellaneousAmountDetailsData: tempData,
        isShowAutoCompleteMiscPoList: showAutoCompleteList,
      });
    }
  };
  readMiscPOBySearchString(searchString) {
    let searchCriteria = new PurchaseOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.purchaseOrderNumberStartsWith = searchString;
    searchCriteria.purchaseOrderNumberContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestPurchaseOrderListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    PurchaseOrderService.getPurchaseOrderPageList(
      cust_requestInput,
      this.readMiscPoBySearchStringResponse,
      this.readPurchaseOrderBySearchStringError
    );
  }
  readMiscPoBySearchStringResponse = (response) => {
    let purchaseorderData = response.data.purchaseOrderPageList.purchaseOrders;
    let simpleAutoCompleteList = new Array();
    if (purchaseorderData.length > 0 && purchaseorderData != null) {
      purchaseorderData.map((po) => {
        let simpleItemBean = {
          code: po.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      MiscPoPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  unlockVendorInvoiceResponse = (response) => {
    this.setState({ isLoading: false });
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editVendorInvoice(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unlockVendorInvoiceError = (error) => {
    let errList = [];
    errList.push(error.toString());
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
    });
  };
  unlockVendorInvoice = (code) => {
    this.setState({ isLoading: true });
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.VendorInvoice_IsAccessible()) {
      AccountPayableService.unLockVendorInvoiceCode(
        request,
        this.unlockVendorInvoiceResponse,
        this.unlockVendorInvoiceError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  hideAlertCallBacklvl3 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertlvl3: isDisplayed });
  };
  hideAlertCallBackLvl5 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl5: isDisplayed });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    isShowPopup = false;
    this.setState({
      isShowAlert: isShowPopup,
    });
  };
  closeAlertModalCallBacklvl3 = (isShowPopup) => {
    isShowPopup = false;
    this.setState({
      isShowReceiptsPopup: isShowPopup,
      isShowAlertlvl3: isShowPopup,
    });
  };
  closeAlertModalCallBacklvl5 = (isShowPopup) => {
    isShowPopup = false;
    this.setState({
      isShowMiscPopup: isShowPopup,
      isShowPOPopup: isShowPopup,
      isShowAdjustmentPopup: isShowPopup,
      isShowAlertLvl5: isShowPopup,

      vendorInvoicePurchaseOrderData: new VendorInvoicePurchaseOrderBean(),
      purchaseReceipts: [],
      purchaseOrderReceipts: [],
      availableReceipts: [],
      selectedReceipts: [],
      receipts: [],
      vendorInvoiceMiscellaneousAmountDetailsData:
        new VendorInvoiceMiscellaneousAmountDetailsBean(),

      vendorInvoiceAdjustmentData: new VendorInvoiceAdjustmentAmountBean(),
    });
    // this.clearMiscLineValues();
    // this.clearPOLineValues(e);
    // this.clearAdjLineValues();
  };
  closeModalCallBack = (isOpen) => {
    this.setState({ isShowPurchaseOrderModule: isOpen, moduleForPopup: [] });
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let vendorInvoiceList = this.state.vendorInvoiceList;
    if (sortField) {
      const sorted = [...vendorInvoiceList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ vendorInvoiceList: sorted });
    }
  };
  render() {
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let vendorInvoiceAdjustmentData = this.state.vendorInvoiceAdjustmentData;
    let isDisableFields = this.state.isDisableFields;
    let vendorInvoiceMiscellaneousAmountDetailsData =
      this.state.vendorInvoiceMiscellaneousAmountDetailsData;
    let vendorInvoicePurchaseOrderData =
      this.state.vendorInvoicePurchaseOrderData;
    let receipts = [];
    receipts = this.state.receipts;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        {!this.state.isSpecialViewMode ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editVendorInvoice}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.vendorInvoiceLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isSpecialViewMode={this.state.isSpecialViewMode}
          isResetView={this.state.isResetView}
          isFocusLookup={this.state.isFocusLookup}
        />
        {!this.state.isListFormOpen && this.state.isViewMode == false && (
          <BaseToolBar
            isShowCancelButton={this.state.isShowCancelButton}
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isLoading={this.state.isLoading}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={false}
            pageTitle={this.state.pageTitle}
            isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
            onModuleKeyContainerButtonClick={this.editVendorInvoice}
            moduleKeyCode={this.state.moduleKeyCode}
            onModuleKeyCodeChange={this.onModuleKeyCodeChange}
            extend_toolbar={
              <>
                {this.state.isShowApproveButton && (
                  <Button
                    className="header_buttons secondary"
                    size="sm"
                    onClick={(e) => this.approveVendorInvoice(e)}
                  >
                    Approve
                  </Button>
                )}
                {this.state.isShowCancelButton && (
                  <Button
                    className="header_buttons secondary"
                    size="sm"
                    onClick={(e) => this.cancelVendorInvoice(e)}
                  >
                    Cancel
                  </Button>
                )}
              </>
            }
          />
        )}
        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedNodeKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={moduleOrderStatus}
          />
        )}
        {!this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          this.state.isEntryFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isListFormOpen &&
          this.state.isEntryFormOpen &&
          this.getHeaderView()}
        {this.state.selectedNodeKey == "invoiceLinesView" &&
          !this.state.isEntryFormOpen &&
          !this.state.isHistoryFormOpened &&
          this.state.isInvoiceLinesDetailsFormOpened &&
          this.getInvoiceLinesView()}
        {this.state.isHistoryFormOpened &&
          !this.state.isEntryFormOpen &&
          this.state.selectedNodeKey == "historyView" &&
          this.getHistoryView()}
        {this.state.isPaymentDetailViewOpen &&
          !this.state.isEntryFormOpen &&
          this.state.selectedNodeKey == "paymentDetailView" &&
          this.getPaymentDetailView()}
        {this.state.isListFormOpen && this.getListView()}
        <ReasonCaptureComponent
          ref={this.cancelReasonDialogRef}
          reasons={this.state.cancelReasons}
          reasonData={this.state.reasonData}
          title="VendorInvoice Cancel"
          isShowPopup={this.state.isShowCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          onChange={this.onReasonChange}
          onClick={this.onCancelReasonContinue}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel5"}
          isModulePopup={false}
          isShowPopup={this.state.isShowPOPopup}
          closeOnEsc={true}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl5}
          title={"PurchaseOrder_Detail"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl5}
              hideAlertCallBack={this.hideAlertCallBackLvl5}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                disabled={isDisableFields}
                onClick={(e) => this.saveVendorPurchaseOrderLine(e)}
              >
                add/update
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                disabled={isDisableFields}
                onClick={(e) => this.clearPOLineValues(e)}
              >
                clear
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel>Line#</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    onChange={this.onPurchaseOrderChange}
                    disabled={true}
                    name="lineNumber"
                    placeholder="LineNumber"
                    value={vendorInvoicePurchaseOrderData.lineNumber}
                  ></InputTextbox>
                </Col>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">
                    Purcahse Order#
                  </FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    onChange={this.purchaseOrderOnChange}
                    name="purchaseOrderNumber"
                    ref={this.purchaseRef}
                    value={vendorInvoicePurchaseOrderData.purchaseOrderNumber}
                    lookupRequired={this.state.isShowPOLookup}
                    lookupHandler={this.state.purchaseorderLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.poEnterKeyEventHandler}
                    autoCompleteListData={
                      this.state.poPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayPoAutoCompleteList}
                    showAutoCompleteList={this.state.isShowAutoCompletePoList}
                    disabled={!this.state.isShowPOLookup}
                    isMandatory={true}
                  />
                </Col>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel>Order Date</FormLabel>
                </Col>
                <Col sm="4">
                  <DatePickerComponent_adv
                    name="purchaseOrderDate"
                    type="date"
                    disabled={true}
                    onChange={this.onPurchaseOrderChange}
                    value={vendorInvoicePurchaseOrderData.purchaseOrderDate}
                  />
                </Col>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel>Order StopDate</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <DatePickerComponent_adv
                    name="purchaseOrderStopDate"
                    disabled={true}
                    type="date"
                    onChange={this.onPurchaseOrderChange}
                    value={vendorInvoicePurchaseOrderData.purchaseOrderStopDate}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">PO Receipts</FormLabel>{" "}
                  <Col>
                    <ShortCutMenuPopup
                      value={"Select PO Receipts"}
                      menuItems={
                        <ul>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) => this.showReceiptsLines(e)}
                          >
                            {" "}
                            Select PO Receipts{" "}
                          </li>
                        </ul>
                      }
                    />
                  </Col>
                </Col>
                <Col sm="4">
                  <InputTextbox
                    name="receipts"
                    onChange={this.onPurchaseOrderChange}
                    readOnly={true}
                    value={receipts}
                  />{" "}
                </Col>
              </Row>
            </div>
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel5"}
          isModulePopup={false}
          isShowPopup={this.state.isShowMiscPopup}
          closeOnEsc={true}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl5}
          title={"Misc_Amount_Detail"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl5}
              hideAlertCallBack={this.hideAlertCallBackLvl5}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                disabled={isDisableFields}
                onClick={(e) => this.addOrUpdate_Miscellaneous(e)}
              >
                add/update
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                disabled={isDisableFields}
                onClick={(e) => this.clearMiscLineValues(e)}
              >
                clear
              </Button>
            </div>
          }
          content={
            <div>
              <Row className="vendor_table_fields">
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">Reason</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    onChange={this.miscReasonOnChange}
                    placeholder="reasonCode"
                    name="reasonCode"
                    ref={this.miscReasonRef}
                    value={
                      vendorInvoiceMiscellaneousAmountDetailsData.reasonCode
                    }
                    lookupRequired={true}
                    lookupHandler={this.state.miscellaneousReasonsLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.miscReasonEnterKeyEvent}
                    autoCompleteListData={
                      this.state.miscReasonPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayMiscReasonAutoCompleteList
                    }
                    showAutoCompleteList={
                      this.state.isShowAutoCompleteMiscreasonList
                    }
                    disabled={isDisableFields}
                    isMandatory={true}
                  />
                </Col>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">Reason Desc</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    onChange={this.onMiscellaneousChange}
                    disabled={true}
                    ref={this.props.miscReasonDescRef}
                    type="text"
                    name="reasonDescription"
                    placeholder="ReasonDescription"
                    value={
                      vendorInvoiceMiscellaneousAmountDetailsData.reasonDescription
                    }
                  ></InputTextbox>
                </Col>
              </Row>
              <Row>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">Amount</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <NumberFormatInputbox
                    name="miscellaneousAmount"
                    className="summary_input text-right"
                    onChange={this.onMiscellaneousChange}
                    value={
                      vendorInvoiceMiscellaneousAmountDetailsData.miscellaneousAmount
                    }
                    disabled={isDisableFields}
                    decimalScale={2}
                    isMandatory={true}
                  />
                </Col>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">PO#</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    onChange={this.MiscPurchaseOrderOnChange}
                    name="purchaseOrderNumber"
                    value={
                      vendorInvoiceMiscellaneousAmountDetailsData.purchaseOrderNumber
                    }
                    lookupRequired={true}
                    lookupHandler={this.state.miscPurchaseOrderLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.MiscpoEnterKeyEventHandler}
                    autoCompleteListData={
                      this.state.MiscPoPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayMiscPoAutoCompleteList}
                    showAutoCompleteList={
                      this.state.isShowAutoCompleteMiscPoList
                    }
                    disabled={isDisableFields}
                    isMandatory={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">Remarks</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    onChange={this.onMiscellaneousChange}
                    disabled={isDisableFields}
                    name="remarks"
                    placeholder="Remarks"
                    value={vendorInvoiceMiscellaneousAmountDetailsData.remarks}
                  ></InputTextbox>
                </Col>
              </Row>
            </div>
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel5"}
          isModulePopup={false}
          isShowPopup={this.state.isShowAdjustmentPopup}
          closeOnEsc={true}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl5}
          title={"Adjustment_Reason_Detail"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl5}
              hideAlertCallBack={this.hideAlertCallBackLvl5}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                disabled={isDisableFields}
                onClick={(e) => this.addOrUpdate_Adj_Reason(e)}
              >
                add/update
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                disabled={isDisableFields}
                onClick={(e) => this.clearAdjLineValues(e)}
              >
                clear
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">
                    Adjustment Reason
                  </FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <InputTextbox
                    onChange={this.adjReasonOnChange}
                    name="adjustmentReason"
                    ref={this.adjReasonRef}
                    value={vendorInvoiceAdjustmentData.adjustmentReason}
                    lookupRequired={true}
                    lookupHandler={this.state.adjReasonLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.adjReasonEnterKeyEvent}
                    autoCompleteListData={
                      this.state.adjReasonPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAdjReasonAutoCompleteList
                    }
                    showAutoCompleteList={
                      this.state.isShowAutoCompleteAdjReasonList
                    }
                    disabled={isDisableFields}
                    isMandatory={true}
                  />
                </Col>
                <Col className="so-align-items-left" sm="2">
                  <FormLabel className="header_labels">Amount</FormLabel>{" "}
                </Col>
                <Col sm="4">
                  <NumberFormatInputbox
                    name="adjustmentAmount"
                    className="summary_input text-right"
                    onChange={this.onAdjustmentChange}
                    value={vendorInvoiceAdjustmentData.adjustmentAmount}
                    disabled={isDisableFields}
                    decimalScale={2}
                    isMandatory={true}
                  />
                </Col>
              </Row>
            </div>
          }
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel3"}
          isModulePopup={false}
          isShowPopup={this.state.isShowReceiptsPopup}
          closeOnEsc={true}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl3}
          title={"PURCHASE RECEIPT DETAIL"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertlvl3}
              hideAlertCallBack={this.hideAlertCallBacklvl3}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.addPoReceipts(e)}
              >
                add/update
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col>
                  <FormLabel>Vendor Invoice</FormLabel>
                </Col>
                <Col>
                  <InputTextbox
                    disabled={true}
                    name="vendorInvoiceCode"
                    value={vendorInvoicePurchaseOrderData.vendorInvoiceCode}
                  ></InputTextbox>
                </Col>
                <Col>
                  <FormLabel>PO Number</FormLabel>
                </Col>
                <Col>
                  <InputTextbox
                    disabled={true}
                    name="purchaseOrderNumber"
                    value={vendorInvoicePurchaseOrderData.purchaseOrderNumber}
                  ></InputTextbox>
                </Col>
              </Row>
              <div className="div_Custom_3">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Purchase Receipt</th>
                      <th>Receipt Date</th>
                      <th>PO Number</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.availableReceipts.map((ln, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            variant="secondry"
                            onClick={(e) =>
                              this.selectPurchaseReceipt(e, ln.code, ln)
                            }
                          >
                            <AddIcon />
                          </Button>
                        </td>
                        <td>{ln.code}</td>
                        <td>{ln.receiptDate}</td>
                        <td>{ln.purchaseOrderNumber}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
              <div className="div_Custom_3">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th></th>
                      <th>Purchase Receipt</th>
                      <th>Receipt Date</th>
                      <th>PO Number</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.selectedReceipts.map((ln) => (
                      <tr>
                        <td>
                          <Button
                            variant="secondry"
                            onClick={(e) =>
                              this.unSelectPurchaseReceipt(e, ln.code, ln)
                            }
                          >
                            <CancelIcon />
                          </Button>
                        </td>
                        <td>{ln.code}</td>
                        <td>{ln.receiptDate}</td>
                        <td>{ln.purchaseOrderNumber}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
class VendorListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  onChange = (e) => {
    this.props.onCriteriaChange(e);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterVendorInvoice();
    }
  };
  filterVendorInvoice = (e) => {
    if (e.detail == 1) this.props.filterVendorInvoice();
  };
  resetFilteredVendorInvoice = (e) => {
    if (e.detail == 1) this.props.resetFilteredVendorInvoice();
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  handleHyperLinkClick = (e, val, rowData) => {
    if (e.detail == 1) this.props.editVendorInvoice(val);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let vendorInvoiceList = new Array();
    if (!isEmptyArray(this.props.vendorInvoiceList)) {
      vendorInvoiceList = this.props.vendorInvoiceList;
    }
    let vendorInvoiceCriteria = this.props.vendorInvoiceCriteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    if (!isEmpty(pageList)) {
      let pageSize = pageList.pageSize;
      let totalCount = pageList.totalCount;
      totalPages = totalCount / pageSize;
      totalPages += totalCount % pageSize == 0 ? 0 : 1;
    }
    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                name="searchName"
                type="text"
                value={vendorInvoiceCriteria.searchName}
                placeholder="Enter Value to Filter.."
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
            </span>
            <span className="px-2"></span>
            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.filterVendorInvoice(e)}>
              Filter
            </Button>
            <span className="px-2"></span>
            <Button
              size="sm"
              onClick={(e) => this.resetFilteredVendorInvoice(e)}
            >
              Reset
            </Button>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Invoice#
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "status")}>
                  Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "status" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "vendorCode")}>
                  Vendor
                  {this.props.order === "desc" &&
                  this.props.sortField === "vendorCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "vendorName")}>
                  VendorName
                  {this.props.order === "desc" &&
                  this.props.sortField === "vendorName" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "invoiceDate")}>
                  Invoice Date
                  {this.props.order === "desc" &&
                  this.props.sortField === "invoiceDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "invoiceDueDate")}
                >
                  Due Date
                  {this.props.order === "desc" &&
                  this.props.sortField === "invoiceDueDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "createdDate")}>
                  Created Date
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "grandTotalAmount")
                  }
                >
                  GrandTotalAmount
                  {this.props.order === "desc" &&
                  this.props.sortField === "grandTotalAmount" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {vendorInvoiceList != null ? (
              <tbody>
                {vendorInvoiceList.map((ln, index) => (
                  <tr key={index}>
                    <td className="hyperLinkText">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.handleHyperLinkClick(e, ln.code)}
                      >
                        {ln.code}
                      </Button>
                    </td>
                    <td>
                      {ModuleUtils.getVendorInvoiceStatusCaption(ln.status)}
                    </td>
                    <td>{ln.vendorCode}</td>
                    <td>{ln.vendorName}</td>
                  <td>{ModuleUtils.getDateFormat_v1(ln.invoiceDate)}</td>
                    <td>{ModuleUtils.getDateFormat_v1(ln.invoiceDueDate)}</td>
                    <td>{ModuleUtils.getDateFormat_v1(ln.createdDate)}</td>
                    <td className="text-end">
                      {toCommaSeperatedAmount(ln.grandTotalAmount)}
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {vendorInvoiceList.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class VendorInvoiceEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.invoiceLinesRef = React.createRef();
    this.vendorCodeRef = React.createRef();
    // this.purchaseRef = React.createRef();
    this.state = {
      purchaseOrderLookupHandler: null,
      expenseTypeLookupHandler: null,
      expenseSubTypeLookupHandler: null,
      currencyLookupHandler: null,
      vendorLookupHandler: null,
      miscellaneousReasonsLookupHandler: null,
      adjReasonLookupHandler: null,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.vendorCodeRef.current != null) {
      this.vendorCodeRef.current.focus();
    }
  }
  componentDidUpdate() {
    //
  }
  initLookupHandlers = () => {
    let expenseTypeLookupHandler = new GenericAttributeLookupHandler(
      this.props.expenseTypes,
      "Expense Type"
    );
    this.setState({ expenseTypeLookupHandler: expenseTypeLookupHandler });
    let expenseSubTypeLookupHandler = new GenericAttributeLookupHandler(
      this.props.expenseSubTypes,
      "Expense Sub Type"
    );
    this.setState({ expenseSubTypeLookupHandler: expenseSubTypeLookupHandler });
    let currencyLookupHandler = new GenericAttributeLookupHandler(
      this.props.currencies,
      "Currency"
    );
    this.setState({ currencyLookupHandler: currencyLookupHandler });
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor"
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
  };
  closeEntryForm() {
    this.props.closeEntryForm();
  }
  onVendorInvoiceLineTableChange = (e, line) => {
    this.props.onVendorInvoiceLineTableChange(e, line);
  };
  addOrUpdate_Adj_Reason = () => {
    this.props.addOrUpdate_Adj_Reason();
  };
  addOrUpdate_Miscellaneous = (e) => {
    this.props.addOrUpdate_Miscellaneous();
  };
  deleteMiscLines = (e, val,rowData) => {
    if (e.detail == 1) this.props.deleteMiscLines(rowData);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  vendorCodeOnChange = (e) => {
    this.props.vendorCodeOnChange(e);
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    this.props.vendorCodeEnterKeyEventHandler(e);
  };
  /**
   *
   * @param {boolean} showAutoCompleteList
   * return boolean
   */
  displayVendorAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayVendorAutoCompleteList(showAutoCompleteList);
  };
  onAdjustmentChange = (e) => {
    this.props.onAdjustmentChange(e);
  };
  onMiscellaneousChange = (e) => {
    this.props.onMiscellaneousChange(e);
  };
  onPurchaseOrderChange = (e) => {
    this.props.onPurchaseOrderChange(e);
  };
  onMiscellaneousDetailsLoad = (e, row, data) => {
    this.props.onMiscellaneousDetailsLoad(e, row);
  };
  handleMiscLineNumberClick = (e, val, rowData) => {
    if (e.detail == 1) this.props.getMiscLineDetails(rowData);
  };
  getAdjustmentLineDetails = (e, val, rowData) => {
    if (e.detail == 1) this.props.getAdjustmentLineDetails(val, rowData);
  };
  deletePoLines = (e,val, rowData) => {
    if (e.detail == 1) this.props.deletePoLines(rowData);
  };
  deleteAdjLines = (e,rowData) => {
    if (e.detail == 1) this.props.deleteAdjLines(rowData);
  };
  saveVendorPurchaseOrderLine = () => {
    this.props.saveVendorPurchaseOrderLine();
  };
  onCheckBoxClick = (e) => {
    this.props.onCheckBoxClick(e);
  };
  onselectableRowSelected = (row) => {
    this.props.onselectableRowSelected(row);
  };
  onPurchaseOrderLineChange = (e) => {
    this.props.onPurchaseOrderLineChange(e);
  };
  addPoReceipts = () => {
    this.props.addPoReceipts();
  };
  showReceiptsLines = () => {
    this.props.showReceiptsLines();
  };
  clearAdjLineValues = () => {
    this.props.clearAdjLineValues();
  };
  clearMiscLineValues = () => {
    this.props.clearMiscLineValues();
  };
  // clearPurchaseLineValues = () => {
  //   this.props.clearPOLineValues();
  // };
  getInvoiceLinecolumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PurchaseReceipt#",
        "code",
        0,
        false,
        null,
        false,
        null,
        "1rem",
        "5rem"
      )
    );
    return columnList;
  };
  lnkPOModule = (e, code, rowData) => {
    if (e.detail == 1) this.props.lnkPOModule(code);
  };
  openMiscPopup = (e) => {
    if (e.detail == 1) this.props.openMiscPopup();
  };
  openPOPopup = (e) => {
    if (e.detail == 1) this.props.openPOPopup();
  };
  openAdjPopup = (e) => {
    if (e.detail == 1) this.props.openAdjPopup();
  };
  closeAlertModalCallBacklvl3 = (isShowPopup) => {
    this.props.closeAlertModalCallBacklvl3(isShowPopup);
  };
  hideAlertCallBacklvl3 = (msgType, isDisplayed) => {
    this.props.hideAlertCallBacklvl3(msgType, isDisplayed);
  };
  closeAlertModalCallBacklvl5 = (isShowPopup) => {
    this.props.closeAlertModalCallBacklvl5(isShowPopup);
  };
  hideAlertCallBackLvl5 = (msgType, isDisplayed) => {
    this.props.hideAlertCallBackLvl5(msgType, isDisplayed);
  };
  /**
   *
   * @param {boolean} isOpen
   * return boolean
   */
  closeModalCallBack = (isOpen) => {
    this.props.closeModalCallBack(isOpen);
  };
  selectPurchaseReceipt = (value, rowData) => {
    this.props.selectPurchaseReceipt(value, rowData);
  };
  unSelectPurchaseReceipt = (value, rowData) => {
    this.props.unSelectPurchaseReceipt(value, rowData);
  };
  handlePoLineNumberClick = (e, val, rowData) => {
    if (e.detail == 1) this.props.handlePoLineNumberClick(rowData);
  };
  expenseTypeOnChange = (e) => {
    this.props.expenseTypeOnChange(e);
  };
  expenseTypeEnterKeyEvent = (e) => {
    this.props.expenseTypeEnterKeyEvent(e);
  };
  displayExpenseTypeAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayExpenseTypeAutoCompleteList(showAutoCompleteList);
  };
  expenseSubTypeOnChange = (e) => {
    this.props.expenseSubTypeOnChange(e);
  };
  expenseSubTypeEnterKeyEvent = (e) => {
    this.props.expenseSubTypeEnterKeyEvent(e);
  };
  displayExpenseSubTypeAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayExpenseSubTypeAutoCompleteList(showAutoCompleteList);
  };
  currencyOnChange = (e) => {
    this.props.currencyOnChange(e);
  };
  currencyEnterKeyEvent = (e) => {
    this.props.currencyEnterKeyEvent(e);
  };
  displayCurrencyAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayCurrencyAutoCompleteList(showAutoCompleteList);
  };
  miscReasonOnChange = (e) => {
    this.props.miscReasonOnChange(e);
  };
  miscReasonEnterKeyEvent = (e) => {
    this.props.miscReasonEnterKeyEvent(e);
  };
  displayMiscReasonAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayMiscReasonAutoCompleteList(showAutoCompleteList);
  };
  adjReasonOnChange = (e) => {
    this.props.adjReasonOnChange(e);
  };
  adjReasonEnterKeyEvent = (e) => {
    this.props.adjReasonEnterKeyEvent(e);
  };
  displayAdjReasonAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayAdjReasonAutoCompleteList(showAutoCompleteList);
  };
  purchaseOrderOnChange = (e) => {
    this.props.purchaseOrderOnChange(e);
  };
  poEnterKeyEventHandler = (e) => {
    this.props.poEnterKeyEventHandler(e);
  };
  displayPoAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayPoAutoCompleteList(showAutoCompleteList);
  };
  MiscPurchaseOrderOnChange = (e) => {
    this.props.MiscPurchaseOrderOnChange(e);
  };
  MiscpoEnterKeyEventHandler = (e) => {
    this.props.MiscpoEnterKeyEventHandler(e);
  };
  displayMiscPoAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayMiscPoAutoCompleteList(showAutoCompleteList);
  };


    poLineColumns = () => {
      const columns = new Array();
      columns.push(
        new ColumnDefinition()
          .setHeaderDetails(true, <AddIcon />, this.openPOPopup, false)
          .setStyleDetails("", "", "", "wt-2", "wt-2")
          .setDetails("Ln#", "lineNumber", true)
          .setClickDetails(true, false, this.handlePoLineNumberClick, null)
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("PO#", "purchaseOrderNumber", true)
          .setStyleDetails("left", "", "", "min-wt-2", "min-wt-2")
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("OrderDate", "purchaseOrderDate", true, false, true)
          .setStyleDetails("left", "", "", "min-wt-2", "min-wt-2")
      );
       columns.push(
        new ColumnDefinition()
          .setDetails("OrderStopDate", "purchaseOrderStopDate", true, false, true)
          .setStyleDetails("left", "", "", "min-wt-2", "min-wt-2")
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("PR#", "purchaseOrderReceiptNumber", true, false)
          .setStyleDetails("left", "", "", "min-wt-2", "min-wt-2")
      );
      // columns.push(
      //   new ColumnDefinition()
      //     .setDetails("PR Date", "purchaseOrderReceiptDate", true, false, true)
      //     .setStyleDetails("left", "", "", "min-wt-2", "min-wt-2")
      // );
      // columns.push(
      //   new ColumnDefinition()
      //     .setDetails(
      //       "PR Approvals",
      //       "purchaseOrderReceiptApprovalNumber",
      //       true,
      //       false
      //     )
      //     .setStyleDetails("left", "", "", "min-wt-7", "min-wt-7")
      // );
      // columns.push(
      //   new ColumnDefinition()
      //     .setDetails("Amount", "approvalAmount", true, true)
      //     .setStyleDetails("right", "", "", "min-wt-2", "min-wt-2")
      // );
      columns.push(
        new ColumnDefinition()
          .setDetails("", <DeleteIcon />, false)
          // .setHeaderDetails(true, <AddIcon />, this.addNewSalesOrderLine, false)
          // .setStyleDetails("", "", "", "wt-2", "wt-2")
  
          .setClickDetails(false, true, this.deletePoLines, <DeleteIcon />)
      );
      return columns;
    };
    //miscLineColumns
  
    miscLineColumns = () => {
      const columns = new Array();
      columns.push(
        new ColumnDefinition()
          .setHeaderDetails(true, <AddIcon />, this.openMiscPopup, false)
          .setStyleDetails("", "", "", "wt-2", "wt-2")
          .setDetails("Ln#", "lineNumber", true)
          .setClickDetails(true, false, this.handleMiscLineNumberClick, null)
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Reason", "reasonCode", true)
          .setStyleDetails("left", "", "", "min-wt-2", "min-wt-2")
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Reason Desc", "reasonDescription", true)
          .setStyleDetails("left", "", "", "min-wt-2", "min-wt-2")
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("PO", "purchaseOrderNumber", true, false, true)
          .setStyleDetails("left", "", "", "min-wt-2", "min-wt-2")
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Amount", "miscellaneousAmount", true, true)
          .setStyleDetails("left", "", "", "min-wt-2", "min-wt-2")
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("", <DeleteIcon />, false)
          // .setHeaderDetails(true, <AddIcon />, this.addNewSalesOrderLine, false)
          // .setStyleDetails("", "", "", "wt-2", "wt-2")
  
          .setClickDetails(false, true, this.deleteMiscLines, <DeleteIcon />)
      );
      return columns;
    };
  
  render() {
    let isDisableFields = this.props.isDisableFields;
    let vendorInvoiceData = this.props.vendorInvoiceData;
    let vendorInvoicePurchaseOrderData =
      this.props.vendorInvoicePurchaseOrderData;
    let receipts = this.props.receipts;
    let vendorInvoiceMiscellaneousAmountDetailsData =
      this.props.vendorInvoiceMiscellaneousAmountDetailsData;
    let vendorInvoiceAdjustmentData = this.props.vendorInvoiceAdjustmentData;
    let isDisabledFields = this.props.isDisabledFields;
    let invPurchaseOrders = [];
    if (this.props.vendorInvoiceData.invoicePurchaseOrders != null) {
      invPurchaseOrders = vendorInvoiceData.invoicePurchaseOrders;
    }
    let miscellaneousAmount = 0;
    vendorInvoiceData = this.props.vendorInvoiceData;
    let miscellaneousAmountDetails = [];
    if (vendorInvoiceData.miscellaneousAmountDetails != null) {
      vendorInvoiceData.miscellaneousAmountDetails.map((miscLine) => {
        miscellaneousAmountDetails.push(miscLine);
        miscellaneousAmount += miscLine.miscellaneousAmount;
      });
    }
    miscellaneousAmount = parseFloat(miscellaneousAmount);
    let adjAmounts = [];
    if (vendorInvoiceData.adjustmentAmounts != null) {
      vendorInvoiceData.adjustmentAmounts.map((adjLine) => {
        adjAmounts.push(adjLine);
      });
    }
    let purchaseOrderReceipts = this.props.purchaseOrderReceipts;
    // let Receipts_table = [];
    // let receipt_string = "";
    // vendorInvoiceData.invoicePurchaseOrders.map((inv) => {
    //   inv.purchaseReceipts.map((ln) => {
    //     Receipts_table.push(ln.purchaseReceiptNumber);
    //   });
    // });
    // receipt_string = Receipts_table.toString();
    const textAreaStyle = {
      height: "15em",
      width: "30em",
      resize: "none",
      padding: "10px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    return (
      <div className="header_div">
        <div>
          <Row>
            <Col className="so-align-items-left" sm="1">
              <FormLabel className="header_labels">VendorCode</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.vendorCodeRef}
                onChange={this.vendorCodeOnChange}
                disabled={isDisableFields}
                name="vendorCode"
                placeholder="VendorCode"
                value={vendorInvoiceData.vendorCode}
                lookupRequired={true}
                lookupHandler={this.state.vendorLookupHandler}
                enterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.vendorPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayVendorAutoCompleteList}
                showAutoCompleteList={this.props.isShowAutoCompleteVendorList}
                isMandatory={true}
              ></InputTextbox>
            </Col>
            <Col className="so-align-items-left" sm="1">
              <FormLabel className="header_labels">VendorName</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onChange}
                disabled={true}
                name="vendorName"
                placeholder="VendorName"
                value={vendorInvoiceData.vendorName}
              ></InputTextbox>
            </Col>
            <Col className="so-align-items-left" sm="1">
              <FormLabel className="header_labels">ExpenseType</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.expenseTypeOnChange}
                placeholder="expenseType"
                name="expenseType"
                value={vendorInvoiceData.expenseType}
                lookupRequired={true}
                lookupHandler={this.state.expenseTypeLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.expenseTypeEnterKeyEvent}
                autoCompleteListData={
                  this.props.expenseTypePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayExpenseTypeAutoCompleteList
                }
                showAutoCompleteList={
                  this.props.isShowAutoCompleteExpenseTypeList
                }
                disabled={isDisableFields}
                isMandatory={true}
              />
            </Col>
            <Col className="so-align-items-left" sm="1">
              <FormLabel>Tolerance%</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                className="text-right"
                onChange={this.onChange}
                name="toleranceForMatchingPercentage"
                placeholder="toleranceForMatchingPercentage"
                value={vendorInvoiceData.toleranceForMatchingPercentage}
                disabled={isDisableFields}
                decimalScale={2}
              />
            </Col>
            {/* <Col className="so-align-items-left" sm="1">
              <FormLabel>Expense Sub Type</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.expenseSubTypeOnChange}
                placeholder="expenseSubType"
                name="expenseSubType"
                value={vendorInvoiceData.expenseSubType}
                lookupRequired={true}
                lookupHandler={this.state.expenseSubTypeLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.expenseSubTypeEnterKeyEvent}
                autoCompleteListData={
                  this.props.expenseSubTypePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayExpenseSubTypeAutoCompleteList
                }
                showAutoCompleteList={
                  this.props.isShowAutoCompleteExpenseSubTypeList
                }
                disabled={isDisableFields}
                isMandatory={true}
              />
            </Col> */}
          </Row>
          <Row className="">
            <Col className="so-align-items-left" sm="1">
              <FormLabel className="header_labels_1">
                Vendor Inv reference
              </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onChange}
                disabled={isDisableFields}
                name="vendorInvoiceReferenceNumber"
                placeholder="VendorInvreference"
                value={vendorInvoiceData.vendorInvoiceReferenceNumber}
                isMandatory={true}
              ></InputTextbox>
            </Col>
            <Col className="so-align-items-left" sm="1">
              <FormLabel className="header_labels_2">Currency</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.currencyOnChange}
                placeholder="currencyCode"
                name="currencyCode"
                value={vendorInvoiceData.currencyCode}
                lookupRequired={true}
                lookupHandler={this.state.currencyLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.currencyEnterKeyEvent}
                autoCompleteListData={
                  this.props.currencyPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayCurrencyAutoCompleteList}
                showAutoCompleteList={this.props.isShowAutoCompleteCurrencyList}
                disabled={true}
              />
            </Col>
            <Col className="so-align-items-left" sm="1">
              <FormLabel header_labels_1>
                OriginalVendor InvoiceAmount
              </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                className="text-right"
                onChange={this.onChange}
                name="originalVendorInvoiceAmount"
                placeholder="OriginalVendorInvoiceAmount"
                value={vendorInvoiceData.originalVendorInvoiceAmount}
                disabled={isDisableFields}
                decimalScale={2}
                isMandatory={true}
              />
            </Col>
            <Col className="so-align-items-left" sm="1">
              <FormLabel className="header_labels_2">Vendor Type</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onChange}
                disabled={isDisableFields}
                name="vendorType"
                placeholder="VendorType"
                value={vendorInvoiceData.vendorType}
              ></InputTextbox>
            </Col>
          </Row>
          <Row className="">
            <Col className="so-align-items-left" sm="1">
              <FormLabel>InvoiceDate</FormLabel>
            </Col>
            <Col sm="2">
              <DatePickerComponent
                disabled={isDisableFields}
                name="invoiceDate"
                value={vendorInvoiceData.invoiceDate}
                onChange={this.onChange}
                isMandatory={true}
              />
            </Col>
            <Col className="so-align-items-left" sm="1">
              <FormLabel>InvoiceDueDate</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <DatePickerComponent
                disabled={isDisableFields}
                name="invoiceDueDate"
                value={vendorInvoiceData.invoiceDueDate}
                onChange={this.onChange}
                isMandatory={true}
              />
            </Col>
            <Col className="so-align-items-left" sm="1">
              <FormLabel>Check#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onChange}
                disabled={true}
                name="appliedCheckReferenceNumber"
                placeholder="appliedCheckReferenceNumber"
                value={vendorInvoiceData.appliedCheckReferenceNumber}
              ></InputTextbox>
            </Col>

            <Col className="so-align-items-left" sm="1">
              <FormLabel>AP Refernce#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="checkTransactionReferenceNumber"
                disabled={true}
                placeholder="AP Refernce"
                value={vendorInvoiceData.checkTransactionReferenceNumber}
              ></InputTextbox>
            </Col>
          </Row>
          {/* <Row>
        
          </Row> */}
        </div>
        <div className="div_inline">
          <div className="div_Equal_no_overflow">
            <div className="div_Custom_1">
                            <>
                              <div className="mt-3">
                                <CustomTable
                                  data={invPurchaseOrders}
                                  columns={this.poLineColumns()} // Consider memoizing
                                  label={"PurchaseOrderLines"}
                                />
                              </div>
                            </>
              {/* <Col className="so-align-items-left">
                <FormLabel>PurchaseOrder</FormLabel>{" "}
              </Col>
              <Table id="fabrics_tables">
                <thead>
                  <tr>
                    <th>
                      <Button
                        size="sm"
                        disabled={isDisableFields}
                        onClick={(e) => this.openPOPopup(e)}
                        id="fabric_Add_Button"
                      >
                        <AddIcon />
                      </Button>
                    </th>
                    <th>Order#</th>
                    <th>OrderDate</th>
                    <th>OrderStopDate</th>
                    <th>Receipts</th>
                    <th></th>
                  </tr>
                </thead>
                {invPurchaseOrders != null ? (
                  <tbody>
                    {invPurchaseOrders.map((ln, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.handlePoLineNumberClick(e, ln.lineNumber, ln)
                            }
                          >
                            {ln.lineNumber}
                          </Button>
                        </td>
                        <td>
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.lnkPOModule(e, ln.purchaseOrderNumber, ln)
                            }
                          >
                            {ln.purchaseOrderNumber}
                          </Button>
                        </td>
                        <td>{ln.purchaseOrderDate}</td>
                        <td>{ln.purchaseOrderStopDate}</td>
                        <td>
                          {ln.purchaseReceipts.map((pr) => (
                            <span>
                              {pr.purchaseReceiptNumber}
                              {","}
                            </span>
                          ))}
                        </td>
                        <td className="text-center">
                          <Button
                            onClick={(e) => this.deletePoLines(e, ln)}
                            disabled={isDisableFields}
                          >
                            <DeleteIcon />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : null}
              </Table>
              {invPurchaseOrders.length != 0 ? null : (
                <div className="no_Data_small">{"NO DATA"}</div>
              )} */}
            </div>
          </div>
          <div className="div_Equal_no_overflow">
            <div className="div_Custom_1">
               <>
                  
                              <div className="mt-3">
                                <CustomTable
                                  data={miscellaneousAmountDetails}
                                  columns={this.miscLineColumns()} // Consider memoizing
                                  label={"Miscellanious Amount Details"}
                                />
                              </div>
                            </>
              {/* <Col className="so-align-items-left">
                <FormLabel>Miscellanious Amount Details</FormLabel>{" "}
              </Col>
              <Table id="fabrics_tables">
                <thead>
                  <tr>
                    <th>
                      <Button
                        size="sm"
                        disabled={isDisableFields}
                        onClick={(e) => this.openMiscPopup(e)}
                        id="fabric_Add_Button"
                      >
                        <AddIcon />
                      </Button>
                    </th>
                    <th>Reason Code</th>
                    <th>Reason Desc</th>
                    <th>PO#</th>
                    <th>Amount</th>
                    <th></th>
                  </tr>
                </thead>
                {miscellaneousAmountDetails != null ? (
                  <tbody>
                    {miscellaneousAmountDetails.map((ln, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.handleMiscLineNumberClick(
                                e,
                                ln.lineNumber,
                                ln
                              )
                            }
                          >
                            {ln.lineNumber}
                          </Button>
                        </td>
                        <td>{ln.reasonCode}</td>
                        <td>{ln.reasonDescription}</td>
                        <td>{ln.purchaseOrderNumber}</td>
                        <td>{ln.miscellaneousAmount}</td>
                        <td className="text-center">
                          <Button
                            onClick={(e) => this.deleteMiscLines(e, ln)}
                            disabled={isDisableFields}
                          >
                            <DeleteIcon />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : null}
              </Table>
              {miscellaneousAmountDetails.length != 0 ? null : (
                <div className="no_Data_small">{"NO DATA"}</div>
              )} */}
            </div>
          </div>
        </div>
        <div className="div_inline">
          <div className="div_40_no_overflow">
            <Col className="so-align-items-left">
              <FormLabel>Adjustment Lines</FormLabel>{" "}
            </Col>
            <div className="div_Custom_1">
              <Table id="fabrics_tables">
                <thead>
                  <tr>
                    <th>
                      <Button
                        size="sm"
                        disabled={isDisableFields}
                        onClick={(e) => this.openAdjPopup(e)}
                        id="fabric_Add_Button"
                      >
                        <AddIcon />
                      </Button>{" "}
                      Reasons
                    </th>
                    <th>Amount</th>
                    <th></th>
                  </tr>
                </thead>
                {adjAmounts != null ? (
                  <tbody>
                    {adjAmounts.map((ln, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.getAdjustmentLineDetails(
                                e,
                                ln.adjustmentReason,
                                ln
                              )
                            }
                          >
                            {ln.adjustmentReason}
                          </Button>
                        </td>
                        <td>{ln.adjustmentAmount}</td>
                        <td className="text-center">
                          <Button
                            onClick={(e) => this.deleteAdjLines(e, ln)}
                            disabled={isDisableFields}
                          >
                            <DeleteIcon />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : null}
              </Table>
              {adjAmounts.length != 0 ? null : (
                <div className="no_Data_small">{"NO DATA"}</div>
              )}
            </div>
          </div>
          <div className="div_30_no_overflow">
            <Col className="so-align-items-left">
              <FormLabel className="label_head">Amount Details</FormLabel>{" "}
            </Col>
            <div className="header_div">
              <Row>
                <Col className="so-align-items-left" sm="4">
                  <FormLabel className="header_labels">
                    Merchandise Amount
                  </FormLabel>{" "}
                </Col>
                <Col sm="8">
                  <NumberFormatInputbox
                    onChange={this.onChange}
                    name="merchandiseAmount"
                    className="summary_input text-right"
                    value={vendorInvoiceData.merchandiseAmount}
                    disabled={isDisableFields}
                    decimalScale={2}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="so-align-items-left" sm="4">
                  <FormLabel className="header_labels">
                    Miscellanious Amount
                  </FormLabel>{" "}
                </Col>
                <Col sm="8">
                  <NumberFormatInputbox
                    onChange={this.onChange}
                    name="miscellaneousAmount"
                    className="summary_input text-right"
                    value={miscellaneousAmount}
                    disabled={true}
                    decimalScale={2}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="so-align-items-left" sm="4">
                  <FormLabel className="header_labels">
                    Adjustment Amount
                  </FormLabel>{" "}
                </Col>
                <Col sm="8">
                  <NumberFormatInputbox
                    onChange={this.onChange}
                    name="adjustmentAmount"
                    className="summary_input text-right"
                    value={vendorInvoiceData.adjustmentAmount}
                    disabled={true}
                    decimalScale={2}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="so-align-items-left" sm="4">
                  <FormLabel className="header_labels">
                    Grand Total Amount
                  </FormLabel>{" "}
                </Col>
                <Col sm="8">
                  <NumberFormatInputbox
                    onChange={this.onChange}
                    name="grandTotalAmount"
                    className="summary_input text-right"
                    value={vendorInvoiceData.grandTotalAmount}
                    disabled={true}
                    decimalScale={2}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="so-align-items-left" sm="4">
                  <FormLabel className="header_labels">Paid Amount</FormLabel>{" "}
                </Col>
                <Col sm="8">
                  <NumberFormatInputbox
                    onChange={this.onChange}
                    name="paidAmount"
                    className="summary_input text-right"
                    value={vendorInvoiceData.paidAmount}
                    disabled={true}
                    decimalScale={2}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="so-align-items-left" sm="4">
                  <FormLabel className="header_labels">Open Amount</FormLabel>{" "}
                </Col>

                <Col sm="8">
                  <NumberFormatInputbox
                    onChange={this.onChange}
                    name="openAmount"
                    className="summary_input text-right"
                    value={vendorInvoiceData.openAmount}
                    disabled={true}
                    decimalScale={2}
                  />
                </Col>
              </Row>
            </div>
          </div>
          <div className="div_30_no_overflow">
            <Col className="so-align-items-left">
              <FormLabel  className="label_head">Comments</FormLabel>{" "}
            </Col>
            <Row>
              <Col>
                <textarea
                  style={textAreaStyle}
                  name="comments"
                  className="form-control"
                  type="text"
                  placeholder="Enter comments"
                  onChange={this.onChange}
                  value={vendorInvoiceData.comments}
                  disabled={isDisabledFields}
                />
              </Col>
            </Row>
          </div>
        </div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
class InvoiceLinesDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
  onLineChange = (e) => {
    this.props.onLineChange(e);
  };
  saveVendorInvoiceLine = (e) => {
    if (e.detail == 1) this.props.saveVendorInvoiceLine();
  };
  clearInvoiceLineValues = (e) => {
    if (e.detail == 1) this.props.clearInvoiceLineValues();
  };
  handleLineNumberClick = (e, val, rowData) => {
    if (e.detail == 1) this.props.openExcitingvendorInvoiceLineForm(rowData);
  };
  render() {
    let currentVendorInvoiceLineData = this.props.vendorInvoiceLineData;
    let vendorInvoiceData = this.props.vendorInvoiceData;
    let _vendorInvoiceLines = new Array();
    if (!isEmptyArray(vendorInvoiceData.invoiceLines)) {
      vendorInvoiceData.invoiceLines.map((line) => {
        _vendorInvoiceLines.push(line);
      });
    } else {
      _vendorInvoiceLines = new Array();
    }
    let isDisabledFields = this.props.isDisabledFields;
    let isDisableFields = this.props.isDisableFields;
    const is3PL = this.props.is3PL;
    return (
      <div>
        <div className="header_div">
          <div className="">
            <Row>
              <Col className="align-fabricStyles-left" sm="1">
                {" "}
                <FormLabel>VendorCode</FormLabel>{" "}
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  name="vendorCode"
                  type="text"
                  placeholder="Enter vendorCode"
                  value={vendorInvoiceData.vendorCode}
                  disabled={true}
                />
              </Col>
              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>VendorName</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="vendorName"
                  type="text"
                  placeholder="Enter vendorName"
                  value={vendorInvoiceData.vendorName}
                  disabled={true}
                />
              </Col>
              <Col className="align-fabricStyles-left" sm="1">
                <FormLabel>TotalAmount</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                  name="grandTotalAmount"
                  className="summary_input text-right"
                  value={vendorInvoiceData.grandTotalAmount}
                  disabled={true}
                  decimalScale={2}
                />
              </Col>
              <Col className="align-fabricStyles-left" sm="1">
                {" "}
                <FormLabel>Currency</FormLabel>{" "}
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  name="currencyCode"
                  type="text"
                  placeholder="CurrencyCode"
                  value={vendorInvoiceData.currencyCode}
                  disabled={true}
                />
              </Col>
            </Row>
            <div className="div_Custom_1">
              <Table id="fabrics_tables_default">
                <thead>
                  <tr>
                    <th>Line#</th>
                    <th>PONumber</th>
                    <th>POReceiptNumber</th>
                    {is3PL ? <th>Item</th> : <th>FabricStyle</th>}
                    {is3PL ? <th>Item Desc</th> : <th>Fabric Desc</th>}

                    <th>Width</th>
                    <th>Color</th>
                    <th>UOM</th>
                    <th>RecdQty</th>
                    <th>Total Line Amount</th>
                    {/* <th>InvoiceQty</th> */}
                  </tr>
                </thead>
                {_vendorInvoiceLines != null ? (
                  <tbody>
                    {_vendorInvoiceLines.map((ln, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.handleLineNumberClick(e, ln.lineNumber, ln)
                            }
                          >
                            {ln.lineNumber}
                          </Button>
                        </td>
                        <td>{ln.purchaseOrderNumber}</td>
                        <td>{ln.purchaseReceiptNumber}</td>
                        <td>{ln.fabricStyleCode}</td>
                        <td>{ln.fabricStyleName}</td>
                        <td>{ln.widthCode}</td>
                        <td>{ln.colorCode}</td>
                        <td>{ln.uomCode}</td>
                        <td>{ln.receivedQuantity}</td>
                        <td>{ln.lineAmount}</td>
                        {/* <td>{ln.invoiceQuantity}</td> */}
                      </tr>
                    ))}
                  </tbody>
                ) : null}
              </Table>
              {_vendorInvoiceLines.length != 0 ? null : (
                <div className="no_Data">{"NO DATA"}</div>
              )}
            </div>
            <div>
              <Row>
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>Ln#</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="lineNumber"
                    readOnly={true}
                    value={currentVendorInvoiceLineData.lineNumber}
                    disabled={true}
                  />{" "}
                </Col>
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>VendorInvoice</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="code"
                    readOnly={true}
                    value={currentVendorInvoiceLineData.code}
                    disabled={true}
                  />{" "}
                </Col>

                <Col className="align-items-left" sm="1">
                  {is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>Fabric</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    value={currentVendorInvoiceLineData.fabricStyleCode}
                    readOnly={true}
                    disabled={true}
                  />{" "}
                </Col>
                {/* <Col sm="3">
                  <InputTextbox
                    name="fabricStyleName"
                    readOnly={true}
                    value={currentVendorInvoiceLineData.fabricStyleName}
                    disabled={true}
                  />{" "}
                </Col> */}
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>color#</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="colorCode"
                    value={currentVendorInvoiceLineData.colorCode}
                    readOnly={true}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>{" "}
              <Row>
                {/* <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>width#</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="widthCode"
                    value={currentVendorInvoiceLineData.widthCode}
                    readOnly={true}
                    disabled={true}
                    // disabled={isDisabledFields}
                  />{" "}
                </Col> */}
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>Uom#</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="uomCode"
                    value={currentVendorInvoiceLineData.uomCode}
                    readOnly={true}
                    disabled={true}
                  />{" "}
                </Col>
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>RecdQty</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    name={"receivedQuantity"}
                    value={currentVendorInvoiceLineData.receivedQuantity}
                    className="summary_input text-right"
                    onChange={this.onLineChange}
                    decimalScale={2}
                    disabled={isDisabledFields}
                  />
                </Col>
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>Cost</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    name={"cost"}
                    value={currentVendorInvoiceLineData.cost}
                    className="summary_input text-right"
                    onChange={this.onLineChange}
                    decimalScale={2}
                    disabled={isDisabledFields}
                  />
                </Col>
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>LineAmt</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    name={"lineAmount"}
                    value={currentVendorInvoiceLineData.lineAmount}
                    onChange={this.onLineChange}
                    className="summary_input text-right"
                    decimalScale={2}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="text-center">
                  <Button
                    id="fabric_Add_Button"
                    size="sm"
                    onClick={(e) => this.saveVendorInvoiceLine(e)}
                    disabled={isDisabledFields}
                  >
                    Add / Update
                  </Button>
                  <Button
                    id="fabric_Add_Button"
                    size="sm"
                    onClick={(e) => this.clearInvoiceLineValues(e)}
                    disabled={isDisabledFields}
                  >
                    Clear
                  </Button>
                </Col>
              </Row>{" "}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
class VendorInvoicePaymentDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadPaymentdetail();
  }
  loadPaymentdetail = () => {
    this.props.loadPaymentdetail();
  };
  render() {
    let vendorInvoiceData = this.props.vendorInvoiceData;
    let paymentDetail = this.props.paymentDetailList;
    return (
      <div>
        <div className="header_div">
          <div>
            <Row>
              <Col sm="1">
                <FormLabel>Invoice Amount</FormLabel>
              </Col>

              <Col sm="2">
                <NumberFormatInputbox
                  name={"grandTotalAmount"}
                  value={vendorInvoiceData.grandTotalAmount}
                  className="summary_input text-right"
                  decimalScale={2}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Remaining Amount</FormLabel>
              </Col>
              <Col sm="2">
                <NumberFormatInputbox
                  name={"openAmount"}
                  value={vendorInvoiceData.openAmount}
                  className="summary_input text-right"
                  decimalScale={2}
                  disabled={true}
                />
              </Col>
            </Row>
          </div>
          <div className="div_Custom_3">
            <Table id="fabrics_tables_default">
              <thead>
                <tr>
                  <th>CheckTransaction</th>
                  <th>Type</th>
                  <th>Document#</th>
                  <th>Applied Amount</th>
                  <th>Amount Due</th>
                  <th>Payment Date</th>
                  <th>Post Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              {this.state.isPaymentDetailsDatasFound && (
                <tbody>
                  {paymentDetail.map((detailInfo, index) => (
                    <tr key={index}>
                      <td>{detailInfo.checkTransactionNumber}</td>
                      <td>{detailInfo.paymentType}</td>
                      <td>{detailInfo.documentNumber}</td>
                      <td>{detailInfo.paymentAmount}</td>
                      <td>{detailInfo.amountDue}</td>
                      <td>{detailInfo.paymentDate}</td>
                      <td>{detailInfo.paymentPostDate}</td>
                      <td>{detailInfo.status}</td>
                    </tr>
                  ))}
                </tbody>
              )}
            </Table>
          </div>
        </div>
      </div>
    );
  }
}
class VendorInvoiceHistoryDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() {
    //
  }

  render() {
    let vendorInvoiceData = this.props.vendorInvoiceData;
    let statusTracks = new Array();
    statusTracks = vendorInvoiceData.statusTracks;
    return (
      <div>
        <div className="header_div">
          <div>
            <div className="div_Custom_1">
              <Table id="fabrics_tables_default">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Amount#</th>
                    <th>Status</th>
                    <th>PreviousStatus</th>
                    <th>Remarks</th>
                    <th>DoneBy</th>
                  </tr>
                </thead>
                {statusTracks != null ? (
                  <tbody>
                    {statusTracks.map((ln, index) => (
                      <tr key={index}>
                        <td>{ln.createdDate}</td>
                        <td>{ln.grandTotalAmount}</td>
                        <td>
                          {ModuleUtils.getVendorInvoiceStatusCaption(
                            ln.currentStatus
                          )}{" "}
                        </td>
                        <td>
                          {ModuleUtils.getVendorInvoiceStatusCaption(
                            ln.previousStatus
                          )}{" "}
                        </td>
                        <td>{ln.remarks}</td>
                        <td>{ln.createdBy}</td>
                      </tr>
                    ))}
                  </tbody>
                ) : null}
              </Table>
              {statusTracks.length != 0 ? null : (
                <div className="no_Data_small">{"NO DATA"}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function VendorInvoiceModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <VendorList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default VendorInvoiceModule;
